/* eslint-disable */
// This file is generated by graphql-codegen. Do not edit it manually.

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateString: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Email: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  JSON: { input: any; output: any; }
  TimeString: { input: any; output: any; }
  URL: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AdminDashboardType = {
  __typename?: 'AdminDashboard';
  current: AdminDashboardSummaryType;
  dateFrom: Scalars['DateTime']['output'];
  dateTo: Scalars['DateTime']['output'];
  expensesByCategory: Array<AdminDashboardExpenseCategoryType>;
  organizations: Array<AdminDashboardOrganizationType>;
  previous?: Maybe<AdminDashboardSummaryType>;
  series: Array<AdminDashboardPointType>;
  step: AdminDashboardStepType;
};

export type AdminDashboardExpenseCategoryType = {
  __typename?: 'AdminDashboardExpenseCategory';
  amountUSD: Scalars['Float']['output'];
  category: InternalExpenseCategoryType;
  count: Scalars['Int']['output'];
};

export type AdminDashboardOrganizationType = {
  __typename?: 'AdminDashboardOrganization';
  organizationId: Scalars['ID']['output'];
  paidInvoicesUSD: Scalars['Float']['output'];
  previousSalesUSD: Scalars['Float']['output'];
  revenueShareUSD: Scalars['Float']['output'];
  salesUSD: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type AdminDashboardPointType = {
  __typename?: 'AdminDashboardPoint';
  date: Scalars['DateTime']['output'];
  expensesUSD: Scalars['Float']['output'];
  netIncomeUSD: Scalars['Float']['output'];
  paidInvoicesUSD: Scalars['Float']['output'];
  revenueShareUSD: Scalars['Float']['output'];
  salesUSD: Scalars['Float']['output'];
  viewers: Scalars['Int']['output'];
  views: Scalars['Int']['output'];
};

export enum AdminDashboardStepType {
  DayType = 'DAY',
  MonthType = 'MONTH',
  WeekType = 'WEEK'
}

export type AdminDashboardSummaryType = {
  __typename?: 'AdminDashboardSummary';
  accrualProfitUSD: Scalars['Float']['output'];
  disputesUSD: Scalars['Float']['output'];
  earnedUSD: Scalars['Float']['output'];
  expensesCount: Scalars['Int']['output'];
  expensesUSD: Scalars['Float']['output'];
  grossSalesUSD: Scalars['Float']['output'];
  issuedInvoicesCount: Scalars['Int']['output'];
  issuedInvoicesUSD: Scalars['Float']['output'];
  licensesAccruedUSD: Scalars['Float']['output'];
  netIncomeUSD: Scalars['Float']['output'];
  newOrganizationsCount: Scalars['Int']['output'];
  organizationsWithSalesCount: Scalars['Int']['output'];
  paidInvoicesCount: Scalars['Int']['output'];
  paidInvoicesUSD: Scalars['Float']['output'];
  paidLicensesUSD: Scalars['Float']['output'];
  paidRevenueShareUSD: Scalars['Float']['output'];
  purchasesCount: Scalars['Int']['output'];
  refundsUSD: Scalars['Float']['output'];
  revenueShareUSD: Scalars['Float']['output'];
  salesUSD: Scalars['Float']['output'];
};

export type AdminDashboardTodayType = {
  __typename?: 'AdminDashboardToday';
  activeContractsCount: Scalars['Int']['output'];
  endingSoonCount: Scalars['Int']['output'];
  licenseContractsCount: Scalars['Int']['output'];
  licenseContractsStartingLaterCount: Scalars['Int']['output'];
  licensesMonthlyUSD: Scalars['Float']['output'];
  pendingRevenueShareUSD: Scalars['Float']['output'];
};

export type AdminUnpaidInvoiceType = {
  __typename?: 'AdminUnpaidInvoice';
  amountCurrency: Scalars['String']['output'];
  amountUSD?: Maybe<Scalars['Float']['output']>;
  amountValue: Scalars['Float']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceDate: Scalars['DateTime']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizationTitle: Scalars['String']['output'];
  overdueDays: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type AmountType = {
  __typename?: 'Amount';
  currency: Scalars['String']['output'];
  value: Scalars['Float']['output'];
  valueUSD?: Maybe<Scalars['Float']['output']>;
};

export type AmountInputType = {
  currency: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export enum ApplicationPlatformType {
  AndroidType = 'ANDROID',
  IosType = 'IOS',
  RokuType = 'ROKU',
  WebType = 'WEB'
}

export type AssistantAttachmentType = {
  __typename?: 'AssistantAttachment';
  createdAt: Scalars['DateTime']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  materialized: Scalars['JSON']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  source: Scalars['String']['output'];
  sourceUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export enum AssistantAudienceType {
  PartnerType = 'PARTNER',
  ViewerType = 'VIEWER'
}

export type AssistantConversationType = {
  __typename?: 'AssistantConversation';
  audience: AssistantAudienceType;
  cacheReadTokens: Scalars['Int']['output'];
  cacheWriteTokens: Scalars['Int']['output'];
  costUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  dislikes: Scalars['Int']['output'];
  hasRequest: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inputTokens: Scalars['Int']['output'];
  knowledgeGap: Scalars['Boolean']['output'];
  knowledgeGapQuestions: Array<Scalars['String']['output']>;
  lastMessageAt: Scalars['DateTime']['output'];
  likes: Scalars['Int']['output'];
  messageCount: Scalars['Int']['output'];
  messages: Array<AssistantMessageType>;
  model: Scalars['String']['output'];
  organization?: Maybe<OrganizationType>;
  origin: Scalars['String']['output'];
  originErrorCode?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
  platform?: Maybe<PlatformType>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<ConversationTopicType>;
  user?: Maybe<UserType>;
  /** Касание зрителя на момент начала диалога (у обращения: касание его диалога) */
  utm?: Maybe<AttributionTouchType>;
};

export type AssistantConversationConnectionType = {
  __typename?: 'AssistantConversationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AssistantConversationType>;
};

export type AssistantConversationsFilterInputType = {
  audience?: InputMaybe<AssistantAudienceType>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  hasDislike?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequest?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeGap?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<ConversationTopicType>;
};

export type AssistantMessageType = {
  __typename?: 'AssistantMessage';
  attachments: Array<AssistantAttachmentType>;
  cards: Scalars['JSON']['output'];
  content: Scalars['JSON']['output'];
  costUsd: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: AssistantMessageKindType;
  page?: Maybe<Scalars['JSON']['output']>;
  pageUrl?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<AssistantPlanType>;
  rating?: Maybe<AssistantMessageRatingType>;
  role: AssistantMessageRoleType;
  text: Scalars['String']['output'];
};

export enum AssistantMessageKindType {
  BlockedType = 'BLOCKED',
  ErrorType = 'ERROR',
  OffTopicType = 'OFF_TOPIC',
  PlanResultType = 'PLAN_RESULT',
  TextType = 'TEXT'
}

export enum AssistantMessageRatingType {
  DownType = 'DOWN',
  UpType = 'UP'
}

export enum AssistantMessageRoleType {
  AssistantType = 'ASSISTANT',
  UserType = 'USER'
}

export type AssistantPlanType = {
  __typename?: 'AssistantPlan';
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  notes: Array<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  platform?: Maybe<PlatformType>;
  previews: Scalars['JSON']['output'];
  sources: Array<Scalars['String']['output']>;
  status: AssistantPlanStatusType;
  steps: Array<AssistantPlanStepType>;
  title: Scalars['String']['output'];
  user?: Maybe<UserType>;
};

export type AssistantPlanConnectionType = {
  __typename?: 'AssistantPlanConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AssistantPlanType>;
};

export enum AssistantPlanStatusType {
  CancelledType = 'CANCELLED',
  DoneType = 'DONE',
  DraftType = 'DRAFT',
  FailedType = 'FAILED',
  PartialType = 'PARTIAL',
  RunningType = 'RUNNING'
}

export type AssistantPlanStepType = {
  __typename?: 'AssistantPlanStep';
  dangerous: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  guards: Scalars['JSON']['output'];
  index: Scalars['Int']['output'];
  input: Scalars['JSON']['output'];
  operation: Scalars['String']['output'];
  removedFrom: Array<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  rootField: Scalars['String']['output'];
  status: AssistantPlanStepStatusType;
};

export enum AssistantPlanStepStatusType {
  DoneType = 'DONE',
  FailedType = 'FAILED',
  PendingType = 'PENDING',
  SkippedType = 'SKIPPED'
}

export type AssistantPlansFilterInputType = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  problemsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<AssistantPlanStatusType>;
};

export type AssistantUsageType = {
  __typename?: 'AssistantUsage';
  audience: AssistantAudienceType;
  budgetUsd: Scalars['Float']['output'];
  costUsd: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  messages: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  organization?: Maybe<OrganizationType>;
  platform?: Maybe<PlatformType>;
};

export type AssistantUsageConnectionType = {
  __typename?: 'AssistantUsageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AssistantUsageType>;
};

export type AssistantUsagesFilterInputType = {
  audience?: InputMaybe<AssistantAudienceType>;
  month?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
};

export type AttributionEmailType = {
  __typename?: 'AttributionEmail';
  automationId?: Maybe<Scalars['ID']['output']>;
  /** null: сценарий удалён (кабинет показывает «Удалённая рассылка») или письмо служебное */
  automationName?: Maybe<Scalars['String']['output']>;
  kind: AttributionEmailKindType;
  nodeId?: Maybe<Scalars['String']['output']>;
  /** Имя шаблона служебного письма */
  template?: Maybe<Scalars['String']['output']>;
};

export enum AttributionEmailKindType {
  BroadcastType = 'BROADCAST',
  EventType = 'EVENT',
  JourneyType = 'JOURNEY',
  TransactionalType = 'TRANSACTIONAL'
}

export type AttributionLinkType = {
  __typename?: 'AttributionLink';
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type AttributionTouchType = {
  __typename?: 'AttributionTouch';
  /** Касание восстановлено бэкфиллом: только аналитика, без награды ссылки */
  backfilled: Scalars['Boolean']['output'];
  campaign?: Maybe<Scalars['String']['output']>;
  /** null у старых меток и восстановленных бэкфиллом */
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  email?: Maybe<AttributionEmailType>;
  /** null: ссылки нет. Админка видит ссылку любой платформы */
  link?: Maybe<AttributionLinkType>;
  linkClickId?: Maybe<Scalars['ID']['output']>;
  linkId?: Maybe<Scalars['ID']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type AutocompleteType = {
  __typename?: 'Autocomplete';
  options: Array<Maybe<AutocompleteOptionType>>;
  value: Array<Maybe<AutocompleteOptionType>>;
};

export type AutocompleteOptionType = {
  __typename?: 'AutocompleteOption';
  label: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type AutocompleteOptionWithIdType = {
  __typename?: 'AutocompleteOptionWithID';
  label: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  value: Scalars['ID']['output'];
};

export type AutocompleteTagTypesFilterInputType = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutocompleteTagsFilterInputType = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
};

export type AutocompleteUsersFilterInputType = {
  excludeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type AutocompleteWithIdType = {
  __typename?: 'AutocompleteWithID';
  options: Array<Maybe<AutocompleteOptionWithIdType>>;
  value: Array<Maybe<AutocompleteOptionWithIdType>>;
};

/**  для аватарок и квадратных картинок */
export type AvatarType = {
  __typename?: 'Avatar';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для аватарок и квадратных картинок */
export type AvatarUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для аватарок и квадратных картинок */
export type AvatarWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type AvatarConnectionType = {
  __typename?: 'AvatarConnection';
  count: Scalars['Int']['output'];
  nodes: Array<AvatarType>;
};

export type AvatarsFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BackoffType = {
  __typename?: 'Backoff';
  delay: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/**  для баннеров и широких картинок */
export type BannerType = {
  __typename?: 'Banner';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для баннеров и широких картинок */
export type BannerUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для баннеров и широких картинок */
export type BannerWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type BannerConnectionType = {
  __typename?: 'BannerConnection';
  count: Scalars['Int']['output'];
  nodes: Array<BannerType>;
};

export type BannersFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type BillingSellerType = {
  __typename?: 'BillingSeller';
  address: Scalars['String']['output'];
  bankAccounts: Array<BillingSellerBankAccountType>;
  brandColor: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  filled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoiceLanguage: Scalars['String']['output'];
  invoiceNumberPrefix: Scalars['String']['output'];
  logo?: Maybe<ImageType>;
  registrationNumber: Scalars['String']['output'];
  signerName: Scalars['String']['output'];
  signerPosition: Scalars['String']['output'];
  vatNote: Scalars['String']['output'];
  vatNumber: Scalars['String']['output'];
};

export type BillingSellerBankAccountType = {
  __typename?: 'BillingSellerBankAccount';
  bankAddress: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  beneficiary: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  iban: Scalars['String']['output'];
  instructions: Scalars['String']['output'];
  swift: Scalars['String']['output'];
};

export type BillingSellerBankAccountInputType = {
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  beneficiary?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['String']['input'];
  iban?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  swift?: InputMaybe<Scalars['String']['input']>;
};

export type BillingSellerInputType = {
  address?: InputMaybe<Scalars['String']['input']>;
  bankAccounts?: InputMaybe<Array<BillingSellerBankAccountInputType>>;
  brandColor?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  invoiceLanguage?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberPrefix?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  signerName?: InputMaybe<Scalars['String']['input']>;
  signerPosition?: InputMaybe<Scalars['String']['input']>;
  vatNote?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum CollectionDisplayModeType {
  HorizontalType = 'HORIZONTAL',
  VerticalType = 'VERTICAL'
}

export type CollectionTypeType = {
  __typename?: 'CollectionType';
  collectionDisplayMode?: Maybe<CollectionDisplayModeType>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  platformId: Scalars['ID']['output'];
  showInSearch: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectionTypeConnectionType = {
  __typename?: 'CollectionTypeConnection';
  count: Scalars['Int']['output'];
  nodes: Array<CollectionTypeType>;
};

export type CollectionTypesFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfigType = {
  __typename?: 'Config';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ConfigConnectionType = {
  __typename?: 'ConfigConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ConfigType>;
};

export type ConfigsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConfirmEmailChangeInputType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ContentType = {
  __typename?: 'Content';
  accessStartAt?: Maybe<Scalars['DateTime']['output']>;
  ageRestrictions: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  hideInGeneralLists: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  onlyUsers: Scalars['Boolean']['output'];
  pendingVideo?: Maybe<VideoType>;
  platform?: Maybe<PlatformType>;
  preview?: Maybe<ImageType>;
  processingStatus: ContentProcessingStatusType;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  stream?: Maybe<StreamType>;
  tags: Array<TagType>;
  title: Scalars['String']['output'];
  totalViews: Scalars['Int']['output'];
  transcodingError?: Maybe<Scalars['String']['output']>;
  type: ContentTypeType;
  updatedAt: Scalars['DateTime']['output'];
  verticalPreview?: Maybe<ImageType>;
  video?: Maybe<VideoType>;
};

export type ContentConnectionType = {
  __typename?: 'ContentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContentType>;
};

export enum ContentProcessingStatusType {
  CompleteType = 'COMPLETE',
  ErrorType = 'ERROR',
  NofileType = 'NOFILE',
  ProcessingType = 'PROCESSING'
}

export enum ContentTypeType {
  CollectionType = 'COLLECTION',
  StreamType = 'STREAM',
  VideoType = 'VIDEO'
}

export type ContentsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  streamStatus?: InputMaybe<StreamStatusType>;
  type?: InputMaybe<ContentTypeType>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractType = {
  __typename?: 'Contract';
  billingPeriodMonths: Scalars['Int']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  currency: Scalars['String']['output'];
  dateFrom: Scalars['DateTime']['output'];
  dateTo?: Maybe<Scalars['DateTime']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  invoiceCurrency?: Maybe<Scalars['String']['output']>;
  items: Array<ContractItemType>;
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  organizationId: Scalars['ID']['output'];
  paidPeriodDays: Scalars['Int']['output'];
  paymentPeriodType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractConnectionType = {
  __typename?: 'ContractConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContractType>;
};

export type ContractItemType = {
  __typename?: 'ContractItem';
  amount?: Maybe<AmountType>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContractItemAmountInputType = {
  currency?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type ContractItemInputType = {
  amount?: InputMaybe<ContractItemAmountInputType>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ContractPaymentType = {
  __typename?: 'ContractPayment';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  contract?: Maybe<ContractType>;
  contractId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  exchangeRate?: Maybe<ExchangeRateSnapshotType>;
  expired: Scalars['Boolean']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice?: Maybe<ContractPaymentInvoiceType>;
  invoiceAmount?: Maybe<AmountType>;
  invoiceDate: Scalars['DateTime']['output'];
  invoiceExchangeRate?: Maybe<ExchangeRateSnapshotType>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  lines: Array<ContractPaymentLineType>;
  note?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<OrganizationType>;
  organizationId: Scalars['ID']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  periodFrom: Scalars['DateTime']['output'];
  periodTo: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ContractPaymentConnectionType = {
  __typename?: 'ContractPaymentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ContractPaymentType>;
};

export type ContractPaymentInvoiceType = {
  __typename?: 'ContractPaymentInvoice';
  issuedAt: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
  previousNumbers: Array<ContractPaymentInvoicePreviousNumberType>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sentTo: Array<Scalars['String']['output']>;
};

export type ContractPaymentInvoicePreviousNumberType = {
  __typename?: 'ContractPaymentInvoicePreviousNumber';
  issuedAt: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type ContractPaymentLineType = {
  __typename?: 'ContractPaymentLine';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  itemType: Scalars['String']['output'];
  report?: Maybe<RevenueShareReportType>;
  reportId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type ContractPaymentsFilterInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  hasInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum ContractStatusType {
  ActiveType = 'ACTIVE',
  CanceledType = 'CANCELED',
  FinishedType = 'FINISHED',
  PendingType = 'PENDING'
}

export type ContractsFilterInputType = {
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ContractStatusType>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ConversationTopicType {
  AccessType = 'ACCESS',
  AccountType = 'ACCOUNT',
  OtherType = 'OTHER',
  PaymentType = 'PAYMENT',
  PlaybackType = 'PLAYBACK',
  PurchaseType = 'PURCHASE',
  RefundType = 'REFUND'
}

export type CreateCollectionTypeInputType = {
  collectionDisplayMode?: InputMaybe<CollectionDisplayModeType>;
  platformId: Scalars['ID']['input'];
  showInSearch?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateConfigInputType = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractInputType = {
  billingPeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  currency: Scalars['String']['input'];
  dateFrom: Scalars['DateTime']['input'];
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceCurrency?: InputMaybe<Scalars['String']['input']>;
  items: Array<ContractItemInputType>;
  note?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  paidPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  paymentPeriodType?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateDocumentInputType = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: DocumentTypeType;
};

export type CreateInternalExpenseInputType = {
  amount: Scalars['Float']['input'];
  category: InternalExpenseCategoryType;
  note?: InputMaybe<Scalars['String']['input']>;
  spentAt: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLanguageInputType = {
  code: Scalars['String']['input'];
  native: Scalars['String']['input'];
  title: Scalars['String']['input'];
  translation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMailerConfigInputType = {
  apiKey: Scalars['String']['input'];
  from: Scalars['String']['input'];
  logoId?: InputMaybe<Scalars['ID']['input']>;
  siteEmail: Scalars['String']['input'];
  siteName: Scalars['String']['input'];
  siteUrl: Scalars['URL']['input'];
  title: Scalars['String']['input'];
};

export type CreateOrganizationInputType = {
  altNames?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<PaymentCurrencyType>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeSettings?: InputMaybe<OrganizationFeeSettingsInputType>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<OrganizationStatusType>;
  title: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationUserInputType = {
  email: Scalars['EmailAddress']['input'];
  organizationId: Scalars['String']['input'];
  /** Роли сотрудника. Пусто или не передано: сотрудник получает роль admin. */
  roles?: InputMaybe<Array<OrganizationRoleType>>;
};

export type CreatePlatformInputType = {
  acceptTermsOfServiceOnSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  clientFields?: InputMaybe<Array<CustomFieldInputType>>;
  complianceCustodianAddress?: InputMaybe<Scalars['String']['input']>;
  complianceCustodianName?: InputMaybe<Scalars['String']['input']>;
  customHTML?: InputMaybe<Scalars['String']['input']>;
  customHead?: InputMaybe<Scalars['String']['input']>;
  customTerms?: InputMaybe<Array<PlatformCustomTermInputType>>;
  defaultRowSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  faviconId?: InputMaybe<Scalars['ID']['input']>;
  footer?: InputMaybe<PlatformFooterInputType>;
  gaId?: InputMaybe<Scalars['String']['input']>;
  googleSiteVerification?: InputMaybe<Scalars['String']['input']>;
  hideableHeader?: InputMaybe<Scalars['Boolean']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  isAgeGateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isComplianceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFavoritesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeaturedVideosEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLikesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchIndexingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStreamChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  mailerConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  refundPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showSupportEmail?: InputMaybe<Scalars['Boolean']['input']>;
  showTerms?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<PlatformStatusType>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<PlatformThemeInputType>;
  title: Scalars['String']['input'];
};

export type CreatePlatformMenuItemInputType = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<PlatformMenuItemDialogItemInputType>>;
  label: Scalars['String']['input'];
  linkType?: InputMaybe<PlatformMenuItemLinkTypeType>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['ID']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-пункта, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  type?: InputMaybe<PlatformMenuItemTypeType>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type CreatePlatformPageInputType = {
  blocks?: InputMaybe<Array<PlatformPageBlockInputType>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  path: Scalars['String']['input'];
  platformId: Scalars['ID']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type CreatePostInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateRefundInputType = {
  amount: Scalars['Float']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  paymentId: Scalars['ID']['input'];
};

export type CreateTagInputType = {
  customFieldValues?: InputMaybe<Array<CustomFieldValueInputType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  platformPageId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  typeId?: InputMaybe<Scalars['ID']['input']>;
  verticalImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateTagTypeInputType = {
  customFields?: InputMaybe<Array<CustomFieldInputType>>;
  defaultPreviewType?: InputMaybe<TagPreviewTypeType>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  seoDescription?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateTranslationInputType = {
  fromVersionId?: InputMaybe<Scalars['ID']['input']>;
  namespace: Scalars['String']['input'];
  project: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CreateUserInputType = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Сразу привязать создаваемого партнёра к организации: создаётся членство
   * (OrganizationUser) и организация выставляется текущей. Требует isPartner.
   */
  currentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName: Scalars['String']['input'];
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export enum CurrencyType {
  RubType = 'RUB',
  UsdType = 'USD'
}

export type CustomFieldType = {
  __typename?: 'CustomField';
  helperText?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  multiple?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Array<Maybe<SelectOptionType>>>;
  placeholder?: Maybe<Scalars['String']['output']>;
  required?: Maybe<Scalars['Boolean']['output']>;
  type: CustomFieldTypeType;
};

export type CustomFieldInputType = {
  helperText?: InputMaybe<Scalars['String']['input']>;
  label: Scalars['String']['input'];
  multiple?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  options?: InputMaybe<Array<SelectOptionInputType>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  type: CustomFieldTypeType;
};

export enum CustomFieldTypeType {
  BooleanType = 'BOOLEAN',
  CountryType = 'COUNTRY',
  DateType = 'DATE',
  NumberType = 'NUMBER',
  SelectType = 'SELECT',
  TextType = 'TEXT'
}

export type CustomFieldValueType = {
  __typename?: 'CustomFieldValue';
  label?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type?: Maybe<CustomFieldTypeType>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldValueInputType = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Детальная информация об адресе от DaData */
export type DaDataAddressType = {
  __typename?: 'DaDataAddress';
  /** Район в регионе */
  area?: Maybe<Scalars['String']['output']>;
  /** Тип района (сокращенный) */
  area_type?: Maybe<Scalars['String']['output']>;
  /** Тип района (полный) */
  area_type_full?: Maybe<Scalars['String']['output']>;
  /** Район с типом */
  area_with_type?: Maybe<Scalars['String']['output']>;
  /** Корпус/строение */
  block?: Maybe<Scalars['String']['output']>;
  /** Тип корпуса (сокращенный) */
  block_type?: Maybe<Scalars['String']['output']>;
  /** Тип корпуса (полный) */
  block_type_full?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<Scalars['String']['output']>;
  /** Тип города (сокращенный) */
  city_type?: Maybe<Scalars['String']['output']>;
  /** Тип города (полный) */
  city_type_full?: Maybe<Scalars['String']['output']>;
  /** Город с типом */
  city_with_type?: Maybe<Scalars['String']['output']>;
  /** Страна */
  country: Scalars['String']['output'];
  /** ISO код страны (двухсимвольный) */
  country_iso_code: Scalars['String']['output'];
  /** Федеральный округ */
  federal_district?: Maybe<Scalars['String']['output']>;
  /** ФИАС ID адреса */
  fias_id: Scalars['String']['output'];
  /** Уровень детализации в ФИАС (от 0 до 9) */
  fias_level: Scalars['String']['output'];
  /** Квартира */
  flat?: Maybe<Scalars['String']['output']>;
  /** Тип квартиры (сокращенный) */
  flat_type?: Maybe<Scalars['String']['output']>;
  /** Тип квартиры (полный) */
  flat_type_full?: Maybe<Scalars['String']['output']>;
  /** Широта (географические координаты) */
  geo_lat?: Maybe<Scalars['String']['output']>;
  /** Долгота (географические координаты) */
  geo_lon?: Maybe<Scalars['String']['output']>;
  /** Номер дома */
  house?: Maybe<Scalars['String']['output']>;
  /** Тип дома (сокращенный) */
  house_type?: Maybe<Scalars['String']['output']>;
  /** Тип дома (полный) */
  house_type_full?: Maybe<Scalars['String']['output']>;
  /** КЛАДР ID адреса */
  kladr_id: Scalars['String']['output'];
  /** Почтовый индекс */
  postal_code?: Maybe<Scalars['String']['output']>;
  /** Код точности координат (0-5) */
  qc_geo?: Maybe<Scalars['Int']['output']>;
  /** Регион */
  region: Scalars['String']['output'];
  /** Тип региона (сокращенный) */
  region_type: Scalars['String']['output'];
  /** Тип региона (полный) */
  region_type_full: Scalars['String']['output'];
  /** Регион с типом */
  region_with_type: Scalars['String']['output'];
  /** Населенный пункт */
  settlement?: Maybe<Scalars['String']['output']>;
  /** Тип населенного пункта (сокращенный) */
  settlement_type?: Maybe<Scalars['String']['output']>;
  /** Тип населенного пункта (полный) */
  settlement_type_full?: Maybe<Scalars['String']['output']>;
  /** Населенный пункт с типом */
  settlement_with_type?: Maybe<Scalars['String']['output']>;
  /** Улица */
  street?: Maybe<Scalars['String']['output']>;
  /** Тип улицы (сокращенный) */
  street_type?: Maybe<Scalars['String']['output']>;
  /** Тип улицы (полный) */
  street_type_full?: Maybe<Scalars['String']['output']>;
  /** Улица с типом */
  street_with_type?: Maybe<Scalars['String']['output']>;
};

/** Ответ с подсказками по адресам */
export type DaDataAddressResponseType = {
  __typename?: 'DaDataAddressResponse';
  /** Список найденных адресов */
  suggestions: Array<DaDataAddressSuggestionType>;
};

/** Подсказка по адресу */
export type DaDataAddressSuggestionType = {
  __typename?: 'DaDataAddressSuggestion';
  /** Детальная информация об адресе */
  data: DaDataAddressType;
  /** Полный адрес с индексом */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес в кратком формате (для отображения в списке) */
  value: Scalars['String']['output'];
};

/** Детальная информация о банке от DaData */
export type DaDataBankType = {
  __typename?: 'DaDataBank';
  /** Адрес банка */
  address: DaDataBankAddressType;
  /** БИК банка */
  bic: Scalars['String']['output'];
  /** Корреспондентский счет */
  correspondent_account: Scalars['String']['output'];
  /** ИНН банка */
  inn: Scalars['String']['output'];
  /** КПП банка */
  kpp: Scalars['String']['output'];
  /** Наименования банка */
  name: DaDataBankNameType;
  /** SWIFT код банка */
  swift?: Maybe<Scalars['String']['output']>;
};

/** Адрес банка */
export type DaDataBankAddressType = {
  __typename?: 'DaDataBankAddress';
  /** Адрес (полный) */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес (краткий) */
  value: Scalars['String']['output'];
};

/** Наименования банка */
export type DaDataBankNameType = {
  __typename?: 'DaDataBankName';
  /** Полное наименование */
  full: Scalars['String']['output'];
  /** Платежное наименование */
  payment: Scalars['String']['output'];
  /** Краткое наименование */
  short: Scalars['String']['output'];
};

/** Ответ с подсказками по банкам */
export type DaDataBankResponseType = {
  __typename?: 'DaDataBankResponse';
  /** Список найденных банков */
  suggestions: Array<DaDataBankSuggestionType>;
};

/** Подсказка по банку */
export type DaDataBankSuggestionType = {
  __typename?: 'DaDataBankSuggestion';
  /** Детальная информация о банке */
  data: DaDataBankType;
  /** Полное название банка */
  unrestricted_value: Scalars['String']['output'];
  /** Название банка (краткое) */
  value: Scalars['String']['output'];
};

/** Ограничения по местоположению для поиска */
export type DaDataLocationInputType = {
  /** Название района */
  area?: InputMaybe<Scalars['String']['input']>;
  /** Название города */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Код страны */
  country?: InputMaybe<Scalars['String']['input']>;
  /** ФИАС ID региона/города */
  fias_id?: InputMaybe<Scalars['String']['input']>;
  /** КЛАДР ID региона/города */
  kladr_id?: InputMaybe<Scalars['String']['input']>;
  /** Название региона */
  region?: InputMaybe<Scalars['String']['input']>;
};

/** Детальная информация об организации от DaData */
export type DaDataOrganizationType = {
  __typename?: 'DaDataOrganization';
  /** Адрес организации */
  address: DaDataOrganizationAddressType;
  /** ИНН организации */
  inn: Scalars['String']['output'];
  /** КПП организации */
  kpp: Scalars['String']['output'];
  /** Руководство организации */
  management?: Maybe<DaDataOrganizationManagementType>;
  /** Наименования организации */
  name: DaDataOrganizationNameType;
  /** ОГРН организации */
  ogrn: Scalars['String']['output'];
  /** Состояние организации */
  state: DaDataOrganizationStateType;
};

/** Адрес организации */
export type DaDataOrganizationAddressType = {
  __typename?: 'DaDataOrganizationAddress';
  /** Адрес (полный) */
  unrestricted_value: Scalars['String']['output'];
  /** Адрес (краткий) */
  value: Scalars['String']['output'];
};

/** Руководство организации */
export type DaDataOrganizationManagementType = {
  __typename?: 'DaDataOrganizationManagement';
  /** ФИО руководителя */
  name: Scalars['String']['output'];
  /** Должность руководителя */
  post: Scalars['String']['output'];
};

/** Наименования организации */
export type DaDataOrganizationNameType = {
  __typename?: 'DaDataOrganizationName';
  /** Полное наименование без ОПФ */
  full: Scalars['String']['output'];
  /** Полное наименование с ОПФ */
  full_with_opf: Scalars['String']['output'];
  /** Наименование на латинице */
  latin?: Maybe<Scalars['String']['output']>;
  /** Краткое наименование без ОПФ */
  short: Scalars['String']['output'];
  /** Краткое наименование с ОПФ */
  short_with_opf: Scalars['String']['output'];
};

/** Ответ с подсказками по организациям */
export type DaDataOrganizationResponseType = {
  __typename?: 'DaDataOrganizationResponse';
  /** Список найденных организаций */
  suggestions: Array<DaDataOrganizationSuggestionType>;
};

/** Состояние организации */
export type DaDataOrganizationStateType = {
  __typename?: 'DaDataOrganizationState';
  /** Дата ликвидации (timestamp) */
  liquidation_date?: Maybe<Scalars['Float']['output']>;
  /** Дата регистрации (timestamp) */
  registration_date?: Maybe<Scalars['Float']['output']>;
  /** Статус организации (ACTIVE, LIQUIDATING, LIQUIDATED) */
  status: Scalars['String']['output'];
};

/** Подсказка по организации */
export type DaDataOrganizationSuggestionType = {
  __typename?: 'DaDataOrganizationSuggestion';
  /** Детальная информация об организации */
  data: DaDataOrganizationType;
  /** Полное название организации */
  unrestricted_value: Scalars['String']['output'];
  /** Название организации (краткое) */
  value: Scalars['String']['output'];
};

export type DisputeType = {
  __typename?: 'Dispute';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feeAmount?: Maybe<AmountType>;
  id: Scalars['ID']['output'];
  organization: OrganizationType;
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  organizationId: Scalars['ID']['output'];
  ottkitFeeAmount?: Maybe<AmountType>;
  payment?: Maybe<PaymentType>;
  paymentId: Scalars['ID']['output'];
  providerFeeAmount?: Maybe<AmountType>;
  status: Scalars['String']['output'];
};

export type DisputeConnectionType = {
  __typename?: 'DisputeConnection';
  count: Scalars['Int']['output'];
  nodes: Array<DisputeType>;
};

export type DocumentType = {
  __typename?: 'Document';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  language?: Maybe<LanguageType>;
  languageId?: Maybe<Scalars['ID']['output']>;
  platform?: Maybe<PlatformType>;
  platformId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: DocumentTypeType;
  updatedAt: Scalars['DateTime']['output'];
  version: DocumentVersionType;
  versionIds: Array<Scalars['ID']['output']>;
  versions: Array<DocumentType>;
};

export type DocumentConnectionType = {
  __typename?: 'DocumentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<DocumentType>;
};

export enum DocumentTypeType {
  OttType = 'OTT'
}

export enum DocumentVersionType {
  ArchiveType = 'ARCHIVE',
  LatestType = 'LATEST'
}

export type DocumentsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentTypeType>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExchangeRateSnapshotType = {
  __typename?: 'ExchangeRateSnapshot';
  date: Scalars['DateTime']['output'];
  rate: Scalars['Float']['output'];
  source: Scalars['String']['output'];
};

export enum FeeTypeType {
  FixedType = 'FIXED',
  FixedPercentageSumType = 'FIXED_PERCENTAGE_SUM',
  PercentageType = 'PERCENTAGE'
}

export enum FieldTypeType {
  BooleanType = 'BOOLEAN',
  MultiSelectType = 'MULTI_SELECT',
  SelectType = 'SELECT',
  TextType = 'TEXT'
}

/**  для публичных файлов */
export type FileType = {
  __typename?: 'File';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type FixedFeeAmountType = {
  __typename?: 'FixedFeeAmount';
  currency: PaymentCurrencyType;
  value: Scalars['Float']['output'];
};

export type FixedFeeAmountInputType = {
  currency: PaymentCurrencyType;
  value: Scalars['Float']['input'];
};

/**  для картинок и баннеров 16:9 или 16:x */
export type ImageType = {
  __typename?: 'Image';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  thumbnails: Array<ImageThumbnailType>;
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
};


/**  для картинок и баннеров 16:9 или 16:x */
export type ImageUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};


/**  для картинок и баннеров 16:9 или 16:x */
export type ImageWebpUrlArgsType = {
  format?: InputMaybe<ThumbnailFormatType>;
};

export type ImageConnectionType = {
  __typename?: 'ImageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ImageType>;
};

export type ImageThumbnailType = {
  __typename?: 'ImageThumbnail';
  format: ThumbnailFormatType;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['URL']['output'];
  webpUrl?: Maybe<Scalars['URL']['output']>;
  width: Scalars['Int']['output'];
};

export type ImagesFilterInputType = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InternalExpenseType = {
  __typename?: 'InternalExpense';
  amount: AmountType;
  category: InternalExpenseCategoryType;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  spentAt: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
};

export enum InternalExpenseCategoryType {
  ContractorsType = 'CONTRACTORS',
  InfrastructureType = 'INFRASTRUCTURE',
  LegalType = 'LEGAL',
  MarketingType = 'MARKETING',
  OtherType = 'OTHER',
  SoftwareType = 'SOFTWARE',
  TaxesType = 'TAXES'
}

export type InternalExpenseConnectionType = {
  __typename?: 'InternalExpenseConnection';
  count: Scalars['Int']['output'];
  nodes: Array<InternalExpenseType>;
  totalAmount: AmountType;
};

export type InternalExpensesFilterInputType = {
  category?: InputMaybe<InternalExpenseCategoryType>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type JobOptionsType = {
  __typename?: 'JobOptions';
  attempts?: Maybe<Scalars['Int']['output']>;
  backoff?: Maybe<BackoffType>;
  delay?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  removeOnComplete?: Maybe<Scalars['JSON']['output']>;
  timeout?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type LanguageType = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  native: Scalars['String']['output'];
  title: Scalars['String']['output'];
  translation: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LanguageConnectionType = {
  __typename?: 'LanguageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<LanguageType>;
};

export type LanguagesFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Цель внутренней ссылки и пункта меню (linkType INTERNAL) */
export enum LinkTargetTypeType {
  /** Контент: видео, эфир или коллекция */
  ContentType = 'CONTENT',
  /** Страница платформы */
  PageType = 'PAGE',
  /** Статья */
  PostType = 'POST',
  /** Продукт */
  ProductType = 'PRODUCT',
  /** Тег */
  TagType = 'TAG'
}

export enum LinkTypeType {
  ExternalType = 'EXTERNAL',
  InternalType = 'INTERNAL'
}

export type MailerConfigType = {
  __typename?: 'MailerConfig';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  from: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  logo?: Maybe<ImageType>;
  siteEmail: Scalars['String']['output'];
  siteName: Scalars['String']['output'];
  siteUrl: Scalars['URL']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MailerConfigConnectionType = {
  __typename?: 'MailerConfigConnection';
  count: Scalars['Int']['output'];
  nodes: Array<MailerConfigType>;
};

export type MailerConfigsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketingConsentType = {
  __typename?: 'MarketingConsent';
  at: Scalars['DateTime']['output'];
  utm?: Maybe<AttributionTouchType>;
};

export type MigrationType = {
  __typename?: 'Migration';
  attemptsMade?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MigrationConnectionType = {
  __typename?: 'MigrationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<MigrationType>;
};

export type MigrationLogType = {
  __typename?: 'MigrationLog';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  migrationId: Scalars['ID']['output'];
};

export type MigrationLogConnectionType = {
  __typename?: 'MigrationLogConnection';
  count: Scalars['Int']['output'];
  nodes: Array<MigrationLogType>;
};

export type MigrationLogsFilterInputType = {
  migrationId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type MigrationsFilterInputType = {
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MutationType = {
  __typename?: 'Mutation';
  addRevenueShareReportCorrection: RevenueShareReportType;
  assignSupportRequest: SupportRequestType;
  cancelContract: ContractType;
  cleanQueue: QueueType;
  confirmEmailChange: UserType;
  createCollectionType: CollectionTypeType;
  createConfig: ConfigType;
  createContract: ContractType;
  createDocument: DocumentType;
  createInternalExpense: InternalExpenseType;
  createLanguage: LanguageType;
  createMailerConfig: MailerConfigType;
  createOrganization: OrganizationType;
  createOrganizationUser: OrganizationUserType;
  createPlatform: PlatformType;
  createPlatformMenuItem: PlatformMenuItemType;
  createPlatformPage: PlatformPageType;
  createPost: PostType;
  createRefund: RefundType;
  createTag: TagType;
  createTagType: TagTypeType;
  createTranslation: TranslationType;
  createUser: UserType;
  deleteCollectionTypes: Array<Maybe<CollectionTypeType>>;
  deleteConfigs: Array<Maybe<ConfigType>>;
  deleteContents: Array<Maybe<ContentType>>;
  deleteDocuments: Array<Maybe<DocumentType>>;
  deleteInternalExpenses: Array<Maybe<InternalExpenseType>>;
  deleteLanguages: Array<Maybe<LanguageType>>;
  deleteMailerConfigs: Array<Maybe<MailerConfigType>>;
  deleteOrganizationUsers: Array<Maybe<OrganizationUserType>>;
  deleteOrganizations: Array<Maybe<OrganizationType>>;
  deletePlatformMenuItems: Array<Maybe<PlatformMenuItemType>>;
  deletePlatformPages: Array<Maybe<PlatformPageType>>;
  deletePlatforms: Array<Maybe<PlatformType>>;
  deletePosts: Array<Maybe<PostType>>;
  deleteQueueJobs: Array<Maybe<Scalars['ID']['output']>>;
  deleteQueues: Array<Maybe<QueueType>>;
  deleteTagTypes: Array<Maybe<TagTypeType>>;
  deleteTags: Array<Maybe<TagType>>;
  deleteTranslations: Array<Maybe<TranslationType>>;
  deleteUsers: Array<Maybe<UserType>>;
  issueContractPaymentInvoice: ContractPaymentType;
  migrate: Scalars['String']['output'];
  promoteQueueJob: QueueJobType;
  recalculateRevenueShareReport: RevenueShareReportType;
  reissueContractPaymentInvoice: ContractPaymentType;
  replySupportRequest: SupportRequestType;
  requestEmailChange: Scalars['String']['output'];
  restoreCollectionTypes: Array<Maybe<CollectionTypeType>>;
  restoreConfigs: Array<Maybe<ConfigType>>;
  restoreContents: Array<Maybe<ContentType>>;
  restoreDocuments: Array<Maybe<DocumentType>>;
  restoreInternalExpenses: Array<Maybe<InternalExpenseType>>;
  restoreLanguages: Array<Maybe<LanguageType>>;
  restoreMailerConfigs: Array<Maybe<MailerConfigType>>;
  restoreOrganizationUsers: Array<Maybe<OrganizationUserType>>;
  restoreOrganizations: Array<Maybe<OrganizationType>>;
  restorePlatformMenuItems: Array<Maybe<PlatformMenuItemType>>;
  restorePlatformPages: Array<Maybe<PlatformPageType>>;
  restorePlatforms: Array<Maybe<PlatformType>>;
  restorePosts: Array<Maybe<PostType>>;
  restoreTagTypes: Array<Maybe<TagTypeType>>;
  restoreTags: Array<Maybe<TagType>>;
  restoreTranslations: Array<Maybe<TranslationType>>;
  restoreUsers: Array<Maybe<UserType>>;
  retrimStreamRecording: StreamType;
  retryQueue: QueueType;
  retryQueueJob: QueueJobType;
  sendContractPaymentInvoice: ContractPaymentType;
  setContractPaymentStatus: ContractPaymentType;
  /**
   * Включает или выключает режим «Stripe ведёт подписки». Включение проверяет
   * права ключа (STRIPE_KEY_MISSING_PERMISSIONS), выключение запрещено при
   * живых подписках Stripe Billing (STRIPE_BILLING_HAS_SUBSCRIPTIONS).
   */
  setPlatformStripeBillingMode: PlatformType;
  setSupportRequestStatus: SupportRequestType;
  signIn: SignInOutputType;
  signOut: Scalars['Boolean']['output'];
  syncTranslationWords: TranslationType;
  /**
   * Остановить покупку: доступ истекает сейчас, автопродление подписки
   * выключается (референс whitelabelAdminUpdateProductPurchase с expiredAt=now).
   * Уже истёкшую покупку возвращает без изменений.
   */
  terminateProductPurchase: ProductPurchaseType;
  testMailerConfig: Scalars['Boolean']['output'];
  updateBillingSeller: BillingSellerType;
  updateCollectionType: CollectionTypeType;
  updateConfig: ConfigType;
  updateContract: ContractType;
  updateContractPaymentNote: ContractPaymentType;
  updateDocument: DocumentType;
  updateInternalExpense: InternalExpenseType;
  updateLanguage: LanguageType;
  updateMailerConfig: MailerConfigType;
  updateOrganization: OrganizationType;
  updateOrganizationBillingRequisites: OrganizationType;
  updateOrganizationUserRoles: OrganizationUserType;
  updatePlatform: PlatformType;
  updatePlatformBunnySettings: PlatformType;
  updatePlatformMenuItem: PlatformMenuItemType;
  updatePlatformPage: PlatformPageType;
  updatePlatformStreamingSettings: PlatformType;
  updatePost: PostType;
  /**
   * Правка покупки админом (референс UpdateProductPurchase + EditButton в
   * whitelabel-админке): даты доступа и автопродление подписки. Пустой ввод
   * возвращает покупку как есть.
   */
  updateProductPurchase: ProductPurchaseType;
  updateTag: TagType;
  updateTagType: TagTypeType;
  updateTranslation: TranslationType;
  updateTranslationWords: TranslationType;
  updateUser: UserType;
  uploadAvatar: AvatarType;
  uploadBanner: BannerType;
  uploadFile: FileType;
  uploadImage: ImageType;
  uploadPrivateFile: PrivateFileType;
  verifySignIn: VerifyEmailOutputType;
};


export type MutationAddRevenueShareReportCorrectionArgsType = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAssignSupportRequestArgsType = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationCancelContractArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationCleanQueueArgsType = {
  queueName: Scalars['String']['input'];
  status: Scalars['String']['input'];
};


export type MutationConfirmEmailChangeArgsType = {
  input: ConfirmEmailChangeInputType;
};


export type MutationCreateCollectionTypeArgsType = {
  input: CreateCollectionTypeInputType;
};


export type MutationCreateConfigArgsType = {
  input: CreateConfigInputType;
};


export type MutationCreateContractArgsType = {
  input: CreateContractInputType;
};


export type MutationCreateDocumentArgsType = {
  input: CreateDocumentInputType;
};


export type MutationCreateInternalExpenseArgsType = {
  input: CreateInternalExpenseInputType;
};


export type MutationCreateLanguageArgsType = {
  input: CreateLanguageInputType;
};


export type MutationCreateMailerConfigArgsType = {
  input: CreateMailerConfigInputType;
};


export type MutationCreateOrganizationArgsType = {
  input: CreateOrganizationInputType;
};


export type MutationCreateOrganizationUserArgsType = {
  input: CreateOrganizationUserInputType;
};


export type MutationCreatePlatformArgsType = {
  input: CreatePlatformInputType;
};


export type MutationCreatePlatformMenuItemArgsType = {
  input: CreatePlatformMenuItemInputType;
};


export type MutationCreatePlatformPageArgsType = {
  input: CreatePlatformPageInputType;
};


export type MutationCreatePostArgsType = {
  input: CreatePostInputType;
};


export type MutationCreateRefundArgsType = {
  input: CreateRefundInputType;
};


export type MutationCreateTagArgsType = {
  input: CreateTagInputType;
};


export type MutationCreateTagTypeArgsType = {
  input: CreateTagTypeInputType;
};


export type MutationCreateTranslationArgsType = {
  input: CreateTranslationInputType;
};


export type MutationCreateUserArgsType = {
  input: CreateUserInputType;
};


export type MutationDeleteCollectionTypesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteConfigsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteContentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteDocumentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteInternalExpensesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteLanguagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteMailerConfigsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteOrganizationUsersArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteOrganizationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformMenuItemsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformPagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePlatformsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeletePostsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteQueueJobsArgsType = {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
  queueName: Scalars['String']['input'];
};


export type MutationDeleteQueuesArgsType = {
  names: Array<Scalars['String']['input']>;
};


export type MutationDeleteTagTypesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTagsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTranslationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteUsersArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationIssueContractPaymentInvoiceArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationMigrateArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationPromoteQueueJobArgsType = {
  id: Scalars['ID']['input'];
  queueName: Scalars['String']['input'];
};


export type MutationRecalculateRevenueShareReportArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationReissueContractPaymentInvoiceArgsType = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationReplySupportRequestArgsType = {
  id: Scalars['ID']['input'];
  input: ReplySupportRequestInputType;
};


export type MutationRequestEmailChangeArgsType = {
  input: RequestEmailChangeInputType;
};


export type MutationRestoreCollectionTypesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreConfigsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreContentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreDocumentsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreInternalExpensesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreLanguagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreMailerConfigsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreOrganizationUsersArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreOrganizationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestorePlatformMenuItemsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestorePlatformPagesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestorePlatformsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestorePostsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreTagTypesArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreTagsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreTranslationsArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRestoreUsersArgsType = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationRetrimStreamRecordingArgsType = {
  streamId: Scalars['ID']['input'];
};


export type MutationRetryQueueArgsType = {
  queueName: Scalars['String']['input'];
};


export type MutationRetryQueueJobArgsType = {
  id: Scalars['ID']['input'];
  queueName: Scalars['String']['input'];
};


export type MutationSendContractPaymentInvoiceArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationSetContractPaymentStatusArgsType = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: Scalars['String']['input'];
};


export type MutationSetPlatformStripeBillingModeArgsType = {
  mode: StripeBillingModeType;
  platformId: Scalars['ID']['input'];
};


export type MutationSetSupportRequestStatusArgsType = {
  id: Scalars['ID']['input'];
  input: SetSupportRequestStatusInputType;
};


export type MutationSignInArgsType = {
  input: SignInInputType;
};


export type MutationSyncTranslationWordsArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationTerminateProductPurchaseArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationTestMailerConfigArgsType = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateBillingSellerArgsType = {
  input: BillingSellerInputType;
};


export type MutationUpdateCollectionTypeArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateCollectionTypeInputType;
};


export type MutationUpdateConfigArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateConfigInputType;
};


export type MutationUpdateContractArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateContractInputType;
};


export type MutationUpdateContractPaymentNoteArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateContractPaymentNoteInputType;
};


export type MutationUpdateDocumentArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateDocumentInputType;
};


export type MutationUpdateInternalExpenseArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateInternalExpenseInputType;
};


export type MutationUpdateLanguageArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateLanguageInputType;
};


export type MutationUpdateMailerConfigArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateMailerConfigInputType;
};


export type MutationUpdateOrganizationArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInputType;
};


export type MutationUpdateOrganizationBillingRequisitesArgsType = {
  id: Scalars['ID']['input'];
  input: OrganizationBillingRequisitesInputType;
};


export type MutationUpdateOrganizationUserRolesArgsType = {
  id: Scalars['ID']['input'];
  roles: Array<OrganizationRoleType>;
};


export type MutationUpdatePlatformArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformInputType;
};


export type MutationUpdatePlatformBunnySettingsArgsType = {
  input: UpdateBunnySettingsInputType;
  platformId: Scalars['ID']['input'];
};


export type MutationUpdatePlatformMenuItemArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformMenuItemInputType;
};


export type MutationUpdatePlatformPageArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePlatformPageInputType;
};


export type MutationUpdatePlatformStreamingSettingsArgsType = {
  input: UpdateStreamingSettingsInputType;
  platformId: Scalars['ID']['input'];
};


export type MutationUpdatePostArgsType = {
  id: Scalars['ID']['input'];
  input: UpdatePostInputType;
};


export type MutationUpdateProductPurchaseArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateProductPurchaseInputType;
};


export type MutationUpdateTagArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateTagInputType;
};


export type MutationUpdateTagTypeArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateTagTypeInputType;
};


export type MutationUpdateTranslationArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateTranslationInputType;
};


export type MutationUpdateTranslationWordsArgsType = {
  input: UpdateTranslationWordsInputType;
};


export type MutationUpdateUserArgsType = {
  id: Scalars['ID']['input'];
  input: UpdateUserInputType;
};


export type MutationUploadAvatarArgsType = {
  input: UploadAvatarInputType;
};


export type MutationUploadBannerArgsType = {
  input: UploadBannerInputType;
};


export type MutationUploadFileArgsType = {
  input: UploadFileInputType;
};


export type MutationUploadImageArgsType = {
  input: UploadImageInputType;
};


export type MutationUploadPrivateFileArgsType = {
  input: UploadPrivateFileInputType;
};


export type MutationVerifySignInArgsType = {
  code: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum OrderStatusType {
  CanceledType = 'CANCELED',
  CompletedType = 'COMPLETED',
  CreatedType = 'CREATED',
  DraftType = 'DRAFT',
  NeedsApprovalType = 'NEEDS_APPROVAL',
  NeedsRefundType = 'NEEDS_REFUND',
  PaidType = 'PAID',
  PaymentRequiredType = 'PAYMENT_REQUIRED'
}

export type OrganizationType = {
  __typename?: 'Organization';
  altNames?: Maybe<Array<Scalars['String']['output']>>;
  assistant?: Maybe<OrganizationAssistantSettingsType>;
  billingRequisites: OrganizationBillingRequisitesType;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  currency: PaymentCurrencyType;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feeSettings: OrganizationFeeSettingsType;
  id: Scalars['ID']['output'];
  logo?: Maybe<AvatarType>;
  platform?: Maybe<PlatformType>;
  platformId?: Maybe<Scalars['ID']['output']>;
  slug: Scalars['String']['output'];
  status: OrganizationStatusType;
  sudoUrl?: Maybe<Scalars['URL']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum OrganizationAddressTypeType {
  /** Дополнительный адрес */
  AdditionalType = 'ADDITIONAL',
  /** Юридический адрес */
  LegalType = 'LEGAL',
  /** Почтовый адрес */
  PostalType = 'POSTAL'
}

/** Помощник партнёра (спека 2026-09-24). Пустые значения заменяются дефолтами в рантайме: Sonnet 5, $20 в месяц. */
export type OrganizationAssistantSettingsType = {
  __typename?: 'OrganizationAssistantSettings';
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  monthlyBudgetUsd?: Maybe<Scalars['Float']['output']>;
};

export type OrganizationAssistantSettingsInputType = {
  enabled: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  monthlyBudgetUsd?: InputMaybe<Scalars['Float']['input']>;
};

export type OrganizationBillingRequisitesType = {
  __typename?: 'OrganizationBillingRequisites';
  address: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName: Scalars['String']['output'];
  contractDate?: Maybe<Scalars['DateTime']['output']>;
  contractNumber: Scalars['String']['output'];
  filled: Scalars['Boolean']['output'];
  invoiceEmails: Array<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  vatNumber: Scalars['String']['output'];
};

export type OrganizationBillingRequisitesInputType = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contractDate?: InputMaybe<Scalars['DateTime']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationConnectionType = {
  __typename?: 'OrganizationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<OrganizationType>;
};

export type OrganizationFeeSettingsType = {
  __typename?: 'OrganizationFeeSettings';
  feeType: FeeTypeType;
  fixedFeeAmount: FixedFeeAmountType;
  percentageFee: Scalars['Float']['output'];
  providerFeePayer: ProviderFeePayerType;
};

export type OrganizationFeeSettingsInputType = {
  feeType: FeeTypeType;
  fixedFeeAmount: FixedFeeAmountInputType;
  percentageFee: Scalars['Float']['input'];
  providerFeePayer: ProviderFeePayerType;
};

/** Роль сотрудника внутри организации (OrganizationUser.roles) */
export enum OrganizationRoleType {
  AdminType = 'admin',
  AnalyticsType = 'analytics',
  MarketingType = 'marketing',
  ProductsType = 'products',
  SettingsType = 'settings',
  StreamsType = 'streams',
  UsersType = 'users',
  VideosType = 'videos'
}

export enum OrganizationStatusType {
  ActiveType = 'active',
  InactiveType = 'inactive'
}

export type OrganizationUserType = {
  __typename?: 'OrganizationUser';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  organization: OrganizationType;
  /** Роли сотрудника в организации. Редактируются партнёром в его кабинете. */
  roles: Array<OrganizationRoleType>;
  updatedAt: Scalars['DateTime']['output'];
  user: UserType;
};

export type OrganizationUserConnectionType = {
  __typename?: 'OrganizationUserConnection';
  count: Scalars['Int']['output'];
  nodes: Array<OrganizationUserType>;
};

export type OrganizationUsersFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrganizationsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentType = {
  __typename?: 'Payment';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  buyer?: Maybe<UserType>;
  buyerEmail?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  feeAmount?: Maybe<AmountType>;
  feeSettings?: Maybe<OrganizationFeeSettingsType>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  organization: OrganizationType;
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  organizationId: Scalars['ID']['output'];
  ottkitFeeAmount?: Maybe<AmountType>;
  period: Scalars['Int']['output'];
  platform?: Maybe<PlatformType>;
  platformId: Scalars['ID']['output'];
  product?: Maybe<ProductType>;
  promocodeId?: Maybe<Scalars['ID']['output']>;
  provider: Scalars['String']['output'];
  providerFeeAmount?: Maybe<AmountType>;
  providerPaymentData?: Maybe<Scalars['JSON']['output']>;
  providerPaymentId?: Maybe<Scalars['String']['output']>;
  providerTransactionId?: Maybe<Scalars['String']['output']>;
  purchase?: Maybe<ProductPurchaseType>;
  recurrent: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type PaymentConnectionType = {
  __typename?: 'PaymentConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PaymentType>;
};

export enum PaymentCurrencyType {
  CadType = 'CAD',
  EurType = 'EUR',
  GbpType = 'GBP',
  MdlType = 'MDL',
  PlnType = 'PLN',
  UsdType = 'USD'
}

export type PlatformType = {
  __typename?: 'Platform';
  acceptTermsOfServiceOnSignIn?: Maybe<Scalars['Boolean']['output']>;
  assistant?: Maybe<PlatformAssistantSettingsType>;
  avatar?: Maybe<AvatarType>;
  avatarId?: Maybe<Scalars['ID']['output']>;
  bunnySettings?: Maybe<PlatformBunnySettingsType>;
  clientFields: Array<CustomFieldType>;
  complianceCustodianAddress?: Maybe<Scalars['String']['output']>;
  complianceCustodianName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customHTML?: Maybe<Scalars['String']['output']>;
  customHead?: Maybe<Scalars['String']['output']>;
  customTerms: Array<PlatformCustomTermType>;
  defaultRowSize?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Провайдер, которым платформа играет на самом деле: её собственный, если
   * задан, иначе дефолт инстанса. В отличие от videoProvider никогда не
   * пустой. Кабинет решает по нему, какой мутацией просить загрузку.
   */
  effectiveVideoProvider: VideoProviderType;
  favicon?: Maybe<AvatarType>;
  features: Array<PlatformFeatureType>;
  footer?: Maybe<PlatformFooterType>;
  gaId?: Maybe<Scalars['String']['output']>;
  googleSiteVerification?: Maybe<Scalars['String']['output']>;
  hideableHeader?: Maybe<Scalars['Boolean']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAgeGateEnabled?: Maybe<Scalars['Boolean']['output']>;
  isComplianceEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFavoritesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFeaturedVideosEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLikesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isLiveReactionsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isSearchIndexingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isStreamChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  isVideoChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<LanguageType>;
  languageId?: Maybe<Scalars['ID']['output']>;
  logo?: Maybe<AvatarType>;
  mailerConfigId?: Maybe<Scalars['ID']['output']>;
  /** Дневной лимит входа в одну цепочку рассылок; пусто: значение по умолчанию инстанса (2000). Работает только при фичефлаге MARKETING_EMAILS */
  marketingJourneyEntriesPerDay?: Maybe<Scalars['Int']['output']>;
  /** Квота маркетинговых писем в месяц (рассылки). Работает только при фичефлаге MARKETING_EMAILS */
  marketingMonthlyQuota?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<OrganizationType>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Лимит параллельных просмотров платного контента на зрителя и контент, 1-3; null: без лимита */
  parallelPremiumViewLimit?: Maybe<Scalars['Int']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['URL']['output']>;
  published: Scalars['Boolean']['output'];
  refundPolicyUrl?: Maybe<Scalars['URL']['output']>;
  showCookieBanner?: Maybe<Scalars['Boolean']['output']>;
  showSupportEmail?: Maybe<Scalars['Boolean']['output']>;
  showTerms?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['String']['output'];
  slugHost: Scalars['String']['output'];
  slugUrl: Scalars['URL']['output'];
  status: PlatformStatusType;
  /**
   * True when video upload/playback actually works for this platform: either
   * its own streamingSettings (accountId + apiToken) are configured, or the
   * shared DEFAULT Cloudflare credentials (config cloudflareStream.default)
   * are available as a fallback. Does not expose any secrets.
   */
  streamingAvailable: Scalars['Boolean']['output'];
  streamingSettings?: Maybe<PlatformStreamingSettingsType>;
  /** Кто ведёт подписки платформы: мы (OTTKIT) или Stripe Billing. */
  stripeBillingMode: StripeBillingModeType;
  sudoUrl?: Maybe<Scalars['URL']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  termsOfServiceUrl?: Maybe<Scalars['URL']['output']>;
  theme?: Maybe<PlatformThemeType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
  videoProvider?: Maybe<VideoProviderType>;
};

/** Настройки помощника зрителя платформы. Значения по умолчанию применяются в рантайме, здесь отдаётся то, что реально сохранено. */
export type PlatformAssistantSettingsType = {
  __typename?: 'PlatformAssistantSettings';
  avatar?: Maybe<AvatarType>;
  dailyMessagesPerViewer?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  monthlyBudgetUsd?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
};

export type PlatformAssistantSettingsInputType = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  dailyMessagesPerViewer?: InputMaybe<Scalars['Int']['input']>;
  enabled: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  monthlyBudgetUsd?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Учётные данные Bunny платформы, только для чтения. Секреты наружу не
 * уходят, отдаётся маска и не-секретные поля.
 */
export type PlatformBunnySettingsType = {
  __typename?: 'PlatformBunnySettings';
  apiKeyMask: Scalars['String']['output'];
  cdnHostname: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  libraryId: Scalars['String']['output'];
};

export type PlatformConnectionType = {
  __typename?: 'PlatformConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformType>;
};

export type PlatformCustomTermType = {
  __typename?: 'PlatformCustomTerm';
  label: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type PlatformCustomTermInputType = {
  label: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** Фичефлаг платформы: включается только в админке */
export enum PlatformFeatureType {
  LiveReactionsType = 'LIVE_REACTIONS',
  MarketingEmailsType = 'MARKETING_EMAILS',
  PlayerPollsType = 'PLAYER_POLLS'
}

export type PlatformFooterType = {
  __typename?: 'PlatformFooter';
  social: Array<PlatformSocialType>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlatformFooterInputType = {
  social?: InputMaybe<Array<PlatformSocialInputType>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMenuItemType = {
  __typename?: 'PlatformMenuItem';
  avatar?: Maybe<AvatarType>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  items: Array<PlatformMenuItemDialogItemType>;
  label: Scalars['String']['output'];
  linkType: PlatformMenuItemLinkTypeType;
  mobileIcon?: Maybe<Scalars['String']['output']>;
  /** Куда ведёт пункт: путь цели на витрине или href внешнего пункта */
  path?: Maybe<Scalars['String']['output']>;
  platform: PlatformType;
  /** @deprecated Use targetType PAGE and targetId; removed after the cabinet moves */
  platformPage?: Maybe<PlatformPageType>;
  /** @deprecated Use targetType PAGE and targetId; removed after the cabinet moves */
  platformPageId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use targetType POST and targetId; removed after the cabinet moves */
  post?: Maybe<PostType>;
  /** @deprecated Use targetType POST and targetId; removed after the cabinet moves */
  postId?: Maybe<Scalars['ID']['output']>;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use targetType TAG and targetId; removed after the cabinet moves */
  tag?: Maybe<TagType>;
  /** @deprecated Use targetType TAG and targetId; removed after the cabinet moves */
  tagId?: Maybe<Scalars['ID']['output']>;
  /** id цели INTERNAL-пункта */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Название цели; null, если цели нет на платформе */
  targetTitle?: Maybe<Scalars['String']['output']>;
  /** Тип цели INTERNAL-пункта; null у EXTERNAL и DIALOG */
  targetType?: Maybe<LinkTargetTypeType>;
  /** Абсолютный адрес перехода */
  targetUrl?: Maybe<Scalars['URL']['output']>;
  type: PlatformMenuItemTypeType;
  updatedAt: Scalars['DateTime']['output'];
  visibilityConditions: VisibilityConditionsType;
};

export type PlatformMenuItemConnectionType = {
  __typename?: 'PlatformMenuItemConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformMenuItemType>;
};

export type PlatformMenuItemDialogItemType = {
  __typename?: 'PlatformMenuItemDialogItem';
  id?: Maybe<Scalars['ID']['output']>;
  subItems: Array<PlatformMenuItemDialogSubItemType>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlatformMenuItemDialogItemInputType = {
  subItems: Array<PlatformMenuItemDialogSubItemInputType>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformMenuItemDialogSubItemType = {
  __typename?: 'PlatformMenuItemDialogSubItem';
  href?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<AvatarType>;
  id?: Maybe<Scalars['ID']['output']>;
  mobileIcon?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PlatformMenuItemDialogSubItemInputType = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PlatformMenuItemLinkTypeType {
  ExternalType = 'EXTERNAL',
  InternalType = 'INTERNAL'
}

export enum PlatformMenuItemTypeType {
  DialogType = 'DIALOG',
  LinkType = 'LINK'
}

export type PlatformMenuItemsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformPageType = {
  __typename?: 'PlatformPage';
  blocks: Array<PlatformPageBlockType>;
  countryCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<BannerType>;
  isHomepage: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  platform: PlatformType;
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  visibilityConditions: VisibilityConditionsType;
};

export type PlatformPageBlockType = {
  __typename?: 'PlatformPageBlock';
  component: PlatformPageBlockTypeType;
  id: Scalars['ID']['output'];
  props: Scalars['JSON']['output'];
  visibilityConditions: VisibilityConditionsType;
};

export type PlatformPageBlockInputType = {
  _id?: InputMaybe<Scalars['ID']['input']>;
  component: PlatformPageBlockTypeType;
  props?: InputMaybe<Scalars['JSON']['input']>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export enum PlatformPageBlockTypeType {
  AppsListType = 'APPS_LIST',
  ArchiveType = 'ARCHIVE',
  BannerType = 'BANNER',
  ButtonType = 'BUTTON',
  ContentsType = 'CONTENTS',
  ContinueReadContentsType = 'CONTINUE_READ_CONTENTS',
  ContinueWatchingContentsType = 'CONTINUE_WATCHING_CONTENTS',
  CoverCarouselType = 'COVER_CAROUSEL',
  CustomCoverType = 'CUSTOM_COVER',
  DigitalAssetsType = 'DIGITAL_ASSETS',
  DonationProgressType = 'DONATION_PROGRESS',
  FaqType = 'FAQ',
  FastLinksListType = 'FAST_LINKS_LIST',
  FavoriteContentsType = 'FAVORITE_CONTENTS',
  HtmlType = 'HTML',
  ItemsListType = 'ITEMS_LIST',
  MarkdownType = 'MARKDOWN',
  PackagesType = 'PACKAGES',
  PartnersType = 'PARTNERS',
  PlaylistsType = 'PLAYLISTS',
  PostsType = 'POSTS',
  ProductsType = 'PRODUCTS',
  RedirectType = 'REDIRECT',
  ReviewsType = 'REVIEWS',
  ServicesType = 'SERVICES',
  TagsType = 'TAGS',
  TagCardType = 'TAG_CARD',
  TextType = 'TEXT',
  TvPlayerType = 'TV_PLAYER'
}

export type PlatformPageConnectionType = {
  __typename?: 'PlatformPageConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PlatformPageType>;
};

export type PlatformPagesFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlatformSocialType = {
  __typename?: 'PlatformSocial';
  link: Scalars['URL']['output'];
  type: PlatformSocialTypeType;
};

export type PlatformSocialInputType = {
  link: Scalars['URL']['input'];
  type: PlatformSocialTypeType;
};

export enum PlatformSocialTypeType {
  FacebookType = 'facebook',
  InstagramType = 'instagram',
  OdnoklassnikiType = 'odnoklassniki',
  TelegramType = 'telegram',
  TiktokType = 'tiktok',
  TwitterType = 'twitter',
  VkontakteType = 'vkontakte',
  YoutubeType = 'youtube'
}

export enum PlatformStatusType {
  DisabledType = 'disabled',
  DraftType = 'draft',
  EnabledType = 'enabled'
}

export type PlatformStreamingSettingsType = {
  __typename?: 'PlatformStreamingSettings';
  accountId: Scalars['String']['output'];
  apiTokenMask: Scalars['String']['output'];
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PlatformThemeType = {
  __typename?: 'PlatformTheme';
  palette?: Maybe<PlatformThemePaletteType>;
  typography?: Maybe<PlatformThemeTypographyType>;
};

export type PlatformThemeInputType = {
  palette?: InputMaybe<PlatformThemePaletteInputType>;
  typography?: InputMaybe<PlatformThemeTypographyInputType>;
};

export type PlatformThemePaletteType = {
  __typename?: 'PlatformThemePalette';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<Scalars['String']['output']>;
  secondary?: Maybe<Scalars['String']['output']>;
  type: PlatformThemePaletteTypeType;
};

export type PlatformThemePaletteInputType = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['String']['input']>;
  secondary?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PlatformThemePaletteTypeType>;
};

export enum PlatformThemePaletteTypeType {
  DarkType = 'dark',
  LightType = 'light'
}

export type PlatformThemeTypographyType = {
  __typename?: 'PlatformThemeTypography';
  fontFamily?: Maybe<Scalars['String']['output']>;
  headingFontFamily?: Maybe<Scalars['String']['output']>;
};

export type PlatformThemeTypographyInputType = {
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  headingFontFamily?: InputMaybe<Scalars['String']['input']>;
};

export type PlatformsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlatformStatusType>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PostType = {
  __typename?: 'Post';
  accessOnlyViaLink: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image: ImageType;
  imageId: Scalars['ID']['output'];
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  publishAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  tags: Array<TagType>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PostConnectionType = {
  __typename?: 'PostConnection';
  count: Scalars['Int']['output'];
  nodes: Array<PostType>;
};

export type PostsFilterInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  publishedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

/**  для приватных файлов */
export type PrivateFileType = {
  __typename?: 'PrivateFile';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type ProductType = {
  __typename?: 'Product';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: ProductTypeType;
};

export type ProductPurchaseType = {
  __typename?: 'ProductPurchase';
  buyerEmail?: Maybe<Scalars['String']['output']>;
  disputed: Scalars['Boolean']['output'];
  expiredAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  payment?: Maybe<PaymentType>;
  platformId: Scalars['ID']['output'];
  product: ProductType;
  refunded: Scalars['Boolean']['output'];
  startAt: Scalars['DateTime']['output'];
  subscription?: Maybe<ProductSubscriptionType>;
  subscriptionId?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
};

export type ProductPurchaseConnectionType = {
  __typename?: 'ProductPurchaseConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ProductPurchaseType>;
};

export type ProductSubscriptionType = {
  __typename?: 'ProductSubscription';
  autoRenewEditable: Scalars['Boolean']['output'];
  billingCyclesComplete: Scalars['Int']['output'];
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  currentPeriodEnd: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nextRenewAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  pastDueSince?: Maybe<Scalars['DateTime']['output']>;
  platformId: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  renewAttempts: Scalars['Int']['output'];
  renewDeadlineAt?: Maybe<Scalars['DateTime']['output']>;
  renewErrorReason?: Maybe<RenewErrorReasonType>;
  renewSubscription: Scalars['Boolean']['output'];
  startAt: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export enum ProductTypeType {
  PpvType = 'PPV',
  SubscriptionType = 'SUBSCRIPTION'
}

export enum ProviderFeePayerType {
  InHalfType = 'IN_HALF',
  OrganizationType = 'ORGANIZATION',
  OttkitType = 'OTTKIT'
}

export type PullStateType = {
  __typename?: 'PullState';
  attempt: Scalars['Int']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  lastError?: Maybe<StreamErrorType>;
  maxAttempts: Scalars['Int']['output'];
  sourceUrl: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: PullStatusType;
};

export enum PullStatusType {
  FailedType = 'FAILED',
  RetryingType = 'RETRYING',
  RunningType = 'RUNNING',
  StoppedType = 'STOPPED'
}

export type QueryType = {
  __typename?: 'Query';
  adminDashboard: AdminDashboardType;
  adminDashboardToday: AdminDashboardTodayType;
  adminUnpaidInvoices: Array<AdminUnpaidInvoiceType>;
  assistantConversation?: Maybe<AssistantConversationType>;
  assistantConversations: AssistantConversationConnectionType;
  assistantPlan?: Maybe<AssistantPlanType>;
  assistantPlans: AssistantPlanConnectionType;
  assistantUsages: AssistantUsageConnectionType;
  autocompleteLanguages: AutocompleteWithIdType;
  autocompleteMailerConfigs: AutocompleteWithIdType;
  autocompleteOrganizations: AutocompleteWithIdType;
  autocompletePlatforms: AutocompleteWithIdType;
  autocompleteTagTypes: AutocompleteWithIdType;
  autocompleteTags: AutocompleteWithIdType;
  autocompleteUsers: AutocompleteWithIdType;
  avatar: AvatarType;
  avatars: AvatarConnectionType;
  banner: BannerType;
  banners: BannerConnectionType;
  billingSeller: BillingSellerType;
  collectionType: CollectionTypeType;
  collectionTypes: CollectionTypeConnectionType;
  config: ConfigType;
  configs: ConfigConnectionType;
  content: ContentType;
  contents: ContentConnectionType;
  contract: ContractType;
  contractPayment: ContractPaymentType;
  contractPayments: ContractPaymentConnectionType;
  contracts: ContractConnectionType;
  currentUser?: Maybe<UserType>;
  /**
   * Поиск банка по БИК в DaData.
   * Возвращает точную информацию о банке.
   */
  dadataFindBankByBic: DaDataBankResponseType;
  /**
   * Поиск организации по ИНН в DaData.
   * Возвращает точную информацию об организации.
   */
  dadataFindOrganizationByInn: DaDataOrganizationResponseType;
  /**
   * Получение подсказок по адресам из DaData.
   * Поддерживает поиск по частичному адресу, почтовому индексу, ФИАС ID.
   */
  dadataSuggestAddress: DaDataAddressResponseType;
  /**
   * Получение подсказок по банкам из DaData.
   * Поиск по названию банка, БИК.
   */
  dadataSuggestBank: DaDataBankResponseType;
  /**
   * Получение подсказок по организациям из DaData.
   * Поиск по названию, ИНН, ОГРН организации.
   */
  dadataSuggestOrganization: DaDataOrganizationResponseType;
  disputes: DisputeConnectionType;
  document: DocumentType;
  documents: DocumentConnectionType;
  file: FileType;
  image: ImageType;
  images: ImageConnectionType;
  internalExpense: InternalExpenseType;
  internalExpenses: InternalExpenseConnectionType;
  job: QueueJobType;
  language: LanguageType;
  languages: LanguageConnectionType;
  mailerConfig: MailerConfigType;
  mailerConfigs: MailerConfigConnectionType;
  migration: MigrationType;
  migrationLogs: MigrationLogConnectionType;
  migrations: MigrationConnectionType;
  organization: OrganizationType;
  organizationUser: OrganizationUserType;
  organizationUsers: OrganizationUserConnectionType;
  organizations: OrganizationConnectionType;
  payment?: Maybe<PaymentType>;
  payments: PaymentConnectionType;
  platform: PlatformType;
  platformMenuItem: PlatformMenuItemType;
  platformMenuItems: PlatformMenuItemConnectionType;
  platformPage: PlatformPageType;
  platformPages: PlatformPageConnectionType;
  platforms: PlatformConnectionType;
  post: PostType;
  posts: PostConnectionType;
  privateFile: PrivateFileType;
  productPurchases: ProductPurchaseConnectionType;
  queue: QueueType;
  queues: QueueConnectionType;
  refunds: RefundConnectionType;
  revenueShareReports: RevenueShareReportConnectionType;
  signInLogs: SignInLogConnectionType;
  streamEntrypoint: StreamEntrypointType;
  streamEntrypoints: StreamEntrypointConnectionType;
  subscriptions: SubscriptionConnectionType;
  supportRequest?: Maybe<SupportRequestType>;
  /** Сотрудники организации (роли admin и users) для назначения */
  supportRequestAssignees: Array<UserType>;
  supportRequestMessageOriginal?: Maybe<Scalars['String']['output']>;
  supportRequests: SupportRequestConnectionType;
  supportRequestsOpenCount: Scalars['Int']['output'];
  tag: TagType;
  tagType: TagTypeType;
  tagTypes: TagTypeConnectionType;
  tags: TagConnectionType;
  translation: TranslationType;
  translations: TranslationConnectionType;
  translationsOptions: Array<TranslationOptionType>;
  user: UserType;
  users: UserConnectionType;
};


export type QueryAdminDashboardArgsType = {
  compareFrom?: InputMaybe<Scalars['DateTime']['input']>;
  compareTo?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
};


export type QueryAssistantConversationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAssistantConversationsArgsType = {
  filter?: InputMaybe<AssistantConversationsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssistantPlanArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAssistantPlansArgsType = {
  filter?: InputMaybe<AssistantPlansFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAssistantUsagesArgsType = {
  filter?: InputMaybe<AssistantUsagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAutocompleteLanguagesArgsType = {
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteMailerConfigsArgsType = {
  filter?: InputMaybe<MailerConfigsFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteOrganizationsArgsType = {
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompletePlatformsArgsType = {
  filter?: InputMaybe<PlatformsFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteTagTypesArgsType = {
  filter?: InputMaybe<AutocompleteTagTypesFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteTagsArgsType = {
  filter?: InputMaybe<AutocompleteTagsFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAutocompleteUsersArgsType = {
  filter?: InputMaybe<AutocompleteUsersFilterInputType>;
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryAvatarArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryAvatarsArgsType = {
  filter?: InputMaybe<AvatarsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBannerArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryBannersArgsType = {
  filter?: InputMaybe<BannersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectionTypeArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryCollectionTypesArgsType = {
  filter?: InputMaybe<CollectionTypesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConfigArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryConfigsArgsType = {
  filter?: InputMaybe<ConfigsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContentArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContentsArgsType = {
  filter?: InputMaybe<ContentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContractPaymentArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryContractPaymentsArgsType = {
  filter?: InputMaybe<ContractPaymentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContractsArgsType = {
  filter?: InputMaybe<ContractsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDadataFindBankByBicArgsType = {
  bic: Scalars['String']['input'];
};


export type QueryDadataFindOrganizationByInnArgsType = {
  inn: Scalars['String']['input'];
  kpp?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDadataSuggestAddressArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>>>;
  query: Scalars['String']['input'];
};


export type QueryDadataSuggestBankArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QueryDadataSuggestOrganizationArgsType = {
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>>>;
  query: Scalars['String']['input'];
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryDisputesArgsType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentsArgsType = {
  filter?: InputMaybe<DocumentsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFileArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryImageArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryImagesArgsType = {
  filter?: InputMaybe<ImagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInternalExpenseArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryInternalExpensesArgsType = {
  filter?: InputMaybe<InternalExpensesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJobArgsType = {
  id: Scalars['ID']['input'];
  queueName: Scalars['String']['input'];
};


export type QueryLanguageArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryLanguagesArgsType = {
  filter?: InputMaybe<LanguagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMailerConfigArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryMailerConfigsArgsType = {
  filter?: InputMaybe<MailerConfigsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMigrationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryMigrationLogsArgsType = {
  filter?: InputMaybe<MigrationLogsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMigrationsArgsType = {
  filter?: InputMaybe<MigrationsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationUserArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationUsersArgsType = {
  filter?: InputMaybe<OrganizationUsersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrganizationsArgsType = {
  filter?: InputMaybe<OrganizationsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPaymentArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPaymentsArgsType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformMenuItemArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformMenuItemsArgsType = {
  filter?: InputMaybe<PlatformMenuItemsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformPageArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPlatformPagesArgsType = {
  filter?: InputMaybe<PlatformPagesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformsArgsType = {
  filter?: InputMaybe<PlatformsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryPostsArgsType = {
  filter?: InputMaybe<PostsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPrivateFileArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryProductPurchasesArgsType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQueueArgsType = {
  name: Scalars['String']['input'];
};


export type QueryQueuesArgsType = {
  filter?: InputMaybe<QueuesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRefundsArgsType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRevenueShareReportsArgsType = {
  filter?: InputMaybe<RevenueShareReportsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySignInLogsArgsType = {
  filter?: InputMaybe<SignInLogsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStreamEntrypointArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryStreamEntrypointsArgsType = {
  filter?: InputMaybe<StreamEntrypointsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySubscriptionsArgsType = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySupportRequestArgsType = {
  id: Scalars['ID']['input'];
};


export type QuerySupportRequestAssigneesArgsType = {
  organizationId: Scalars['ID']['input'];
};


export type QuerySupportRequestMessageOriginalArgsType = {
  id: Scalars['ID']['input'];
};


export type QuerySupportRequestsArgsType = {
  filter?: InputMaybe<SupportRequestsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryTagTypeArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryTagTypesArgsType = {
  filter?: InputMaybe<TagTypesFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTagsArgsType = {
  filter?: InputMaybe<TagsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTranslationArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryTranslationsArgsType = {
  filter?: InputMaybe<TranslationsFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgsType = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgsType = {
  filter?: InputMaybe<UsersFilterInputType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueType = {
  __typename?: 'Queue';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobCounts: QueueJobCountsType;
  jobs: QueueJobConnectionType;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type QueueJobsArgsType = {
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueueConnectionType = {
  __typename?: 'QueueConnection';
  count: Scalars['Int']['output'];
  nodes: Array<QueueType>;
};

export type QueueJobType = {
  __typename?: 'QueueJob';
  attemptsMade?: Maybe<Scalars['Int']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  delay?: Maybe<Scalars['Float']['output']>;
  failedReason?: Maybe<Scalars['String']['output']>;
  finished?: Maybe<Scalars['Boolean']['output']>;
  finishedOn?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  logs: Array<Maybe<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  opts: JobOptionsType;
  processedOn?: Maybe<Scalars['DateTime']['output']>;
  progress?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  stacktrace?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  state?: Maybe<Scalars['String']['output']>;
  steps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};


export type QueueJobLogsArgsType = {
  end?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type QueueJobConnectionType = {
  __typename?: 'QueueJobConnection';
  count: Scalars['Int']['output'];
  nodes: Array<QueueJobType>;
};

export type QueueJobCountsType = {
  __typename?: 'QueueJobCounts';
  active: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  delayed: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type QueuesFilterInputType = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RefundType = {
  __typename?: 'Refund';
  amount: AmountType;
  amountInOrganizationCurrency?: Maybe<AmountType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  feeAmount?: Maybe<AmountType>;
  id: Scalars['ID']['output'];
  initiatedBy: Scalars['String']['output'];
  /** Возврат учтён только у нас: деньги покупателю партнёр возвращает руками в кабинете провайдера (старые платежи Paynet). */
  manual: Scalars['Boolean']['output'];
  organization: OrganizationType;
  organizationAmount?: Maybe<AmountType>;
  organizationAmountInOrganizationCurrency?: Maybe<AmountType>;
  organizationId: Scalars['ID']['output'];
  ottkitFeeAmount?: Maybe<AmountType>;
  payment?: Maybe<PaymentType>;
  paymentId: Scalars['ID']['output'];
  providerFeeAmount?: Maybe<AmountType>;
  status: Scalars['String']['output'];
};

export type RefundConnectionType = {
  __typename?: 'RefundConnection';
  count: Scalars['Int']['output'];
  nodes: Array<RefundType>;
};

export enum RenewErrorReasonType {
  CardDeclinedType = 'cardDeclined',
  CardExpiredType = 'cardExpired',
  ChargeFailedType = 'chargeFailed',
  InsufficientFundsType = 'insufficientFunds',
  NoPaymentMethodType = 'noPaymentMethod'
}

export type ReplySupportRequestInputType = {
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  resolve?: InputMaybe<Scalars['Boolean']['input']>;
  text: Scalars['String']['input'];
  viaAssistant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RequestEmailChangeInputType = {
  email: Scalars['EmailAddress']['input'];
  userId: Scalars['ID']['input'];
};

export type RevenueShareReportType = {
  __typename?: 'RevenueShareReport';
  contract?: Maybe<ContractType>;
  contractId: Scalars['ID']['output'];
  contractPaymentId?: Maybe<Scalars['ID']['output']>;
  corrections: Array<RevenueShareReportCorrectionType>;
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  disputesAmount: AmountType;
  disputesCount: Scalars['Int']['output'];
  exchangeRate?: Maybe<ExchangeRateSnapshotType>;
  feeAmount: AmountType;
  feePercentages: Array<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<OrganizationType>;
  organizationId: Scalars['ID']['output'];
  period: Scalars['String']['output'];
  providerFeeAmount: AmountType;
  purchasesCount: Scalars['Int']['output'];
  refundsAmount: AmountType;
  refundsCount: Scalars['Int']['output'];
  reportAmount: AmountType;
  reportAmountInContractCurrency?: Maybe<AmountType>;
  salesAmount: AmountType;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RevenueShareReportConnectionType = {
  __typename?: 'RevenueShareReportConnection';
  count: Scalars['Int']['output'];
  nodes: Array<RevenueShareReportType>;
};

export type RevenueShareReportCorrectionType = {
  __typename?: 'RevenueShareReportCorrection';
  amount: AmountType;
  createdAt: Scalars['DateTime']['output'];
  creatorId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
};

export type RevenueShareReportsFilterInputType = {
  contractId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SelectOptionType = {
  __typename?: 'SelectOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelectOptionInputType = {
  label: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ServiceBillingTypeType {
  OneTimeType = 'ONE_TIME',
  RecurringType = 'RECURRING'
}

export type SetSupportRequestStatusInputType = {
  status: SupportRequestStatusType;
};

export type SignInInputType = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
};

export type SignInLogType = {
  __typename?: 'SignInLog';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  isUsed: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  usedAt?: Maybe<Scalars['DateTime']['output']>;
  user: UserType;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type SignInLogConnectionType = {
  __typename?: 'SignInLogConnection';
  count: Scalars['Int']['output'];
  nodes: Array<SignInLogType>;
};

export type SignInLogsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SignInOutputType = {
  __typename?: 'SignInOutput';
  token: Scalars['String']['output'];
};

export type StreamType = {
  __typename?: 'Stream';
  autoPublishRecord: Scalars['Boolean']['output'];
  cfAccountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dvrEnabled: Scalars['Boolean']['output'];
  enableRecord: Scalars['Boolean']['output'];
  entrypoint?: Maybe<StreamEntrypointType>;
  finishAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isChatEnabled: Scalars['Boolean']['output'];
  lastError?: Maybe<StreamErrorType>;
  lastPublishAt?: Maybe<Scalars['DateTime']['output']>;
  lastPublishFinishAt?: Maybe<Scalars['DateTime']['output']>;
  liveConnected: Scalars['Boolean']['output'];
  liveInputId: Scalars['String']['output'];
  pull?: Maybe<PullStateType>;
  recordContentId?: Maybe<Scalars['ID']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  status: StreamStatusType;
  updatedAt: Scalars['DateTime']['output'];
};

export type StreamEntrypointType = {
  __typename?: 'StreamEntrypoint';
  cfAccountId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastPublishAt?: Maybe<Scalars['DateTime']['output']>;
  lastPublishFinishAt?: Maybe<Scalars['DateTime']['output']>;
  liveConnected: Scalars['Boolean']['output'];
  liveInputId: Scalars['String']['output'];
  platform?: Maybe<PlatformType>;
  pull?: Maybe<PullStateType>;
  stream?: Maybe<ContentType>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StreamEntrypointConnectionType = {
  __typename?: 'StreamEntrypointConnection';
  count: Scalars['Int']['output'];
  nodes: Array<StreamEntrypointType>;
};

export type StreamEntrypointsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StreamErrorType = {
  __typename?: 'StreamError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum StreamStatusType {
  CancelledType = 'CANCELLED',
  FinishedType = 'FINISHED',
  PendingType = 'PENDING',
  StartedType = 'STARTED'
}

export enum StripeBillingModeType {
  OttkitType = 'OTTKIT',
  StripeBillingType = 'STRIPE_BILLING'
}

export type SubscriptionType = {
  __typename?: 'Subscription';
  migrationUpdated: MigrationType;
  newMigrationLogs: MigrationLogType;
};


export type SubscriptionMigrationUpdatedArgsType = {
  id: Scalars['ID']['input'];
};


export type SubscriptionNewMigrationLogsArgsType = {
  migrationId: Scalars['ID']['input'];
};

export type SubscriptionConnectionType = {
  __typename?: 'SubscriptionConnection';
  count: Scalars['Int']['output'];
  nodes: Array<ProductSubscriptionType>;
};

/**
 * Куда ведёт судо-ссылка: PARTNER — кабинет партнёра, SITE — витрина
 * платформы, к которой привязан пользователь.
 */
export enum SudoDestinationType {
  PartnerType = 'PARTNER',
  SiteType = 'SITE'
}

export type SupportRequestType = {
  __typename?: 'SupportRequest';
  assignee?: Maybe<UserType>;
  assistantMessages: Array<AssistantMessageType>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** Технические детали к обращению, только для сотрудников ottkit */
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  message: Scalars['String']['output'];
  messages: Array<SupportRequestMessageType>;
  number?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<OrganizationType>;
  payment?: Maybe<PaymentType>;
  platform?: Maybe<PlatformType>;
  status: SupportRequestStatusType;
  subject: Scalars['String']['output'];
  type: SupportRequestTypeType;
  user?: Maybe<UserType>;
  /** Касание зрителя на момент начала диалога (у обращения: касание его диалога) */
  utm?: Maybe<AttributionTouchType>;
  waitingSince?: Maybe<Scalars['DateTime']['output']>;
};

/** Вложение письма зрителя, url подписан на час */
export type SupportRequestAttachmentType = {
  __typename?: 'SupportRequestAttachment';
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type SupportRequestConnectionType = {
  __typename?: 'SupportRequestConnection';
  count: Scalars['Int']['output'];
  nodes: Array<SupportRequestType>;
};

export enum SupportRequestEventType {
  AssignedType = 'ASSIGNED',
  AutoClosedType = 'AUTO_CLOSED',
  ForeignSenderType = 'FOREIGN_SENDER',
  ReopenedType = 'REOPENED',
  ReopenBlockedType = 'REOPEN_BLOCKED',
  ResolvedType = 'RESOLVED',
  UnassignedType = 'UNASSIGNED'
}

export type SupportRequestMessageType = {
  __typename?: 'SupportRequestMessage';
  attachments: Array<SupportRequestAttachmentType>;
  author: SupportRequestMessageAuthorType;
  body: Scalars['String']['output'];
  channel: SupportRequestMessageChannelType;
  createdAt: Scalars['DateTime']['output'];
  event?: Maybe<SupportRequestEventType>;
  eventUser?: Maybe<UserType>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  hasOriginal: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  skippedAttachments: Scalars['Int']['output'];
  staff?: Maybe<UserType>;
  viaAssistant: Scalars['Boolean']['output'];
};

export enum SupportRequestMessageAuthorType {
  StaffType = 'STAFF',
  SystemType = 'SYSTEM',
  ViewerType = 'VIEWER'
}

export enum SupportRequestMessageChannelType {
  CabinetType = 'CABINET',
  EmailType = 'EMAIL',
  SiteType = 'SITE',
  SystemType = 'SYSTEM'
}

export enum SupportRequestStatusType {
  CancelledType = 'CANCELLED',
  ClosedType = 'CLOSED',
  DraftType = 'DRAFT',
  OpenType = 'OPEN',
  ViewerRepliedType = 'VIEWER_REPLIED',
  WaitingViewerType = 'WAITING_VIEWER'
}

export enum SupportRequestTypeType {
  AccessProblemType = 'ACCESS_PROBLEM',
  OtherType = 'OTHER',
  PaymentProblemType = 'PAYMENT_PROBLEM',
  RefundType = 'REFUND'
}

export type SupportRequestsFilterInputType = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** true: только ждущие ответа команды (OPEN, VIEWER_REPLIED) */
  needsReply?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SupportRequestStatusType>;
  type?: InputMaybe<SupportRequestTypeType>;
};

export type TagType = {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime']['output'];
  customFieldValues: Array<CustomFieldValueType>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageType>;
  imageId?: Maybe<Scalars['ID']['output']>;
  isFeatured: Scalars['Boolean']['output'];
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  platformPage?: Maybe<PlatformPageType>;
  platformPageId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<TagTypeType>;
  typeId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  verticalImage?: Maybe<ImageType>;
  verticalImageId?: Maybe<Scalars['ID']['output']>;
};

export type TagConnectionType = {
  __typename?: 'TagConnection';
  count: Scalars['Int']['output'];
  nodes: Array<TagType>;
};

/**
 * Какая картинка у тегов этого типа основная: HORIZONTAL это 16:9 (image),
 * VERTICAL это портрет 2:3 (verticalImage). Форма тега в партнёрском кабинете
 * открывает этот слот первым, чтобы для актёров не заливали 16:9 по ошибке.
 */
export enum TagPreviewTypeType {
  HorizontalType = 'HORIZONTAL',
  VerticalType = 'VERTICAL'
}

export type TagTypeType = {
  __typename?: 'TagType';
  createdAt: Scalars['DateTime']['output'];
  customFields: Array<CustomFieldType>;
  defaultPreviewType: TagPreviewTypeType;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  organization: OrganizationType;
  organizationId: Scalars['ID']['output'];
  /**
   * Названия тегов этого типа добавляются в meta description страниц видео,
   * стримов, коллекций и тегов на витрине.
   */
  seoDescription: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TagTypeConnectionType = {
  __typename?: 'TagTypeConnection';
  count: Scalars['Int']['output'];
  nodes: Array<TagTypeType>;
};

export type TagTypesFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TagsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ThumbnailFormatType {
  DefaultType = 'DEFAULT',
  HighType = 'HIGH',
  MaxresType = 'MAXRES',
  MediumType = 'MEDIUM',
  SmallType = 'SMALL'
}

export type TranslationType = {
  __typename?: 'Translation';
  createdAt: Scalars['DateTime']['output'];
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  namespace: Scalars['String']['output'];
  project: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  variants: Array<TranslationVariantType>;
  version: Scalars['String']['output'];
};

export type TranslationConnectionType = {
  __typename?: 'TranslationConnection';
  count: Scalars['Int']['output'];
  nodes: Array<TranslationType>;
};

export type TranslationOptionType = {
  __typename?: 'TranslationOption';
  label: Scalars['String']['output'];
  value: Scalars['ID']['output'];
};

export type TranslationVariantType = {
  __typename?: 'TranslationVariant';
  languageCode: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  translated: Scalars['Int']['output'];
  untranslated: Scalars['Int']['output'];
  words: Array<TranslationWordType>;
};

export type TranslationWordType = {
  __typename?: 'TranslationWord';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type TranslationWordInputType = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type TranslationsFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateBunnySettingsInputType = {
  /** Аккаунтный ключ bunny.net. Нужен только плитке расхода. */
  accountApiKey?: InputMaybe<Scalars['String']['input']>;
  apiKey: Scalars['String']['input'];
  cdnHostname: Scalars['String']['input'];
  cdnTokenKey: Scalars['String']['input'];
  libraryId: Scalars['String']['input'];
  readOnlyApiKey: Scalars['String']['input'];
};

export type UpdateCollectionTypeInputType = {
  collectionDisplayMode?: InputMaybe<CollectionDisplayModeType>;
  showInSearch?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConfigInputType = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractInputType = {
  billingPeriodMonths?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  invoiceCurrency?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<ContractItemInputType>>;
  note?: InputMaybe<Scalars['String']['input']>;
  paidPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  paymentPeriodType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractPaymentNoteInputType = {
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDocumentInputType = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  isNewVersion?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DocumentTypeType>;
};

export type UpdateInternalExpenseInputType = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<InternalExpenseCategoryType>;
  note?: InputMaybe<Scalars['String']['input']>;
  spentAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLanguageInputType = {
  code?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMailerConfigInputType = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  siteEmail?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  siteUrl?: InputMaybe<Scalars['URL']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInputType = {
  altNames?: InputMaybe<Array<Scalars['String']['input']>>;
  assistant?: InputMaybe<OrganizationAssistantSettingsInputType>;
  currency?: InputMaybe<PaymentCurrencyType>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeSettings?: InputMaybe<OrganizationFeeSettingsInputType>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatusType>;
  title?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformInputType = {
  acceptTermsOfServiceOnSignIn?: InputMaybe<Scalars['Boolean']['input']>;
  assistant?: InputMaybe<PlatformAssistantSettingsInputType>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  clientFields?: InputMaybe<Array<CustomFieldInputType>>;
  complianceCustodianAddress?: InputMaybe<Scalars['String']['input']>;
  complianceCustodianName?: InputMaybe<Scalars['String']['input']>;
  customHTML?: InputMaybe<Scalars['String']['input']>;
  customHead?: InputMaybe<Scalars['String']['input']>;
  customTerms?: InputMaybe<Array<PlatformCustomTermInputType>>;
  defaultRowSize?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  faviconId?: InputMaybe<Scalars['ID']['input']>;
  features?: InputMaybe<Array<PlatformFeatureType>>;
  footer?: InputMaybe<PlatformFooterInputType>;
  gaId?: InputMaybe<Scalars['String']['input']>;
  googleSiteVerification?: InputMaybe<Scalars['String']['input']>;
  hideableHeader?: InputMaybe<Scalars['Boolean']['input']>;
  host?: InputMaybe<Scalars['String']['input']>;
  isAgeGateEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isComplianceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFavoritesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isFeaturedVideosEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLikesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLiveReactionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchIndexingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isStreamChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  mailerConfigId?: InputMaybe<Scalars['ID']['input']>;
  marketingJourneyEntriesPerDay?: InputMaybe<Scalars['Int']['input']>;
  marketingMonthlyQuota?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parallelPremiumViewLimit?: InputMaybe<Scalars['Int']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  refundPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  showSupportEmail?: InputMaybe<Scalars['Boolean']['input']>;
  showTerms?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PlatformStatusType>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  termsOfServiceUrl?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<PlatformThemeInputType>;
  title?: InputMaybe<Scalars['String']['input']>;
  videoProvider?: InputMaybe<VideoProviderType>;
};

export type UpdatePlatformMenuItemInputType = {
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  href?: InputMaybe<Scalars['String']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<PlatformMenuItemDialogItemInputType>>;
  label?: InputMaybe<Scalars['String']['input']>;
  linkType?: InputMaybe<PlatformMenuItemLinkTypeType>;
  mobileIcon?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  /** Цель INTERNAL-пункта, вместе с targetId */
  targetType?: InputMaybe<LinkTargetTypeType>;
  type?: InputMaybe<PlatformMenuItemTypeType>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type UpdatePlatformPageInputType = {
  blocks?: InputMaybe<Array<PlatformPageBlockInputType>>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isHomepage?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visibilityConditions?: InputMaybe<VisibilityConditionsInputType>;
};

export type UpdatePostInputType = {
  accessOnlyViaLink?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  publishAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductPurchaseInputType = {
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Автопродление подписки этой покупки. У покупки без подписки отказ:
   * продлевать нечего.
   */
  renewSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateStreamingSettingsInputType = {
  accountId: Scalars['String']['input'];
  apiToken: Scalars['String']['input'];
};

export type UpdateTagInputType = {
  customFieldValues?: InputMaybe<Array<CustomFieldValueInputType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageId?: InputMaybe<Scalars['ID']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  platformPageId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  typeId?: InputMaybe<Scalars['ID']['input']>;
  verticalImageId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTagTypeInputType = {
  customFields?: InputMaybe<Array<CustomFieldInputType>>;
  defaultPreviewType?: InputMaybe<TagPreviewTypeType>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  seoDescription?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationInputType = {
  fromVersionId?: InputMaybe<Scalars['ID']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  project?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTranslationWordsInputType = {
  addWords: Array<TranslationWordInputType>;
  languageCode: Scalars['String']['input'];
  removeWords: Array<Scalars['String']['input']>;
  translationId: Scalars['ID']['input'];
};

export type UpdateUserInputType = {
  agreeToMarketingNewsletters?: InputMaybe<Scalars['Boolean']['input']>;
  avatarId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currentOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['ID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UploadAvatarInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadBannerInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadFileInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadImageInputType = {
  file: Scalars['Upload']['input'];
};

export type UploadPrivateFileInputType = {
  file: Scalars['Upload']['input'];
};

export type UserType = {
  __typename?: 'User';
  agreeToMarketingNewsletters?: Maybe<Scalars['Boolean']['output']>;
  apiAuthToken: Scalars['String']['output'];
  avatar?: Maybe<AvatarType>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currentOrganization?: Maybe<OrganizationType>;
  currentOrganizationId?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isPlatformAdmin?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** Последнее известное касание зрителя. */
  lastUtm?: Maybe<AttributionTouchType>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PlatformType>;
  platformId?: Maybe<Scalars['ID']['output']>;
  /** Первое касание на момент регистрации (User.registrationUtm), без срока. */
  registrationUtm?: Maybe<AttributionTouchType>;
  sudoUrl?: Maybe<Scalars['URL']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};


export type UserSudoUrlArgsType = {
  destination: SudoDestinationType;
};

export type UserConnectionType = {
  __typename?: 'UserConnection';
  count: Scalars['Int']['output'];
  nodes: Array<UserType>;
};

export type UsersFilterInputType = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isPlatformAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyEmailOutputType = {
  __typename?: 'VerifyEmailOutput';
  token: Scalars['String']['output'];
};

export type VideoType = {
  __typename?: 'Video';
  createdAt: Scalars['DateTime']['output'];
  duration?: Maybe<Scalars['Float']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  readyToStream: Scalars['Boolean']['output'];
  transcodingError?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

/**
 * Провайдер видео платформы. Пустое значение означает дефолт инстанса
 * (config instance.videoProvider).
 */
export enum VideoProviderType {
  BunnyType = 'BUNNY',
  CloudflareType = 'CLOUDFLARE'
}

export type VisibilityConditionsType = {
  __typename?: 'VisibilityConditions';
  applicationPlatforms: VisibilityConditionsApplicationPlatformsType;
  countries: VisibilityConditionsCountriesType;
  userType?: Maybe<VisibilityConditionsUserTypeType>;
};

export enum VisibilityConditionsApplicationPlatformTypeType {
  AllType = 'ALL',
  ExcludeType = 'EXCLUDE',
  IncludeType = 'INCLUDE'
}

export type VisibilityConditionsApplicationPlatformsType = {
  __typename?: 'VisibilityConditionsApplicationPlatforms';
  platforms: Array<ApplicationPlatformType>;
  type: VisibilityConditionsApplicationPlatformTypeType;
};

export type VisibilityConditionsApplicationPlatformsInputType = {
  platforms?: InputMaybe<Array<ApplicationPlatformType>>;
  type?: InputMaybe<VisibilityConditionsApplicationPlatformTypeType>;
};

export type VisibilityConditionsCountriesType = {
  __typename?: 'VisibilityConditionsCountries';
  countryCodes: Array<Scalars['String']['output']>;
  type: VisibilityConditionsCountriesTypeType;
};

export type VisibilityConditionsCountriesInputType = {
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<VisibilityConditionsCountriesTypeType>;
};

export enum VisibilityConditionsCountriesTypeType {
  AllType = 'ALL',
  ExcludeType = 'EXCLUDE',
  IncludeType = 'INCLUDE'
}

export type VisibilityConditionsInputType = {
  applicationPlatforms?: InputMaybe<VisibilityConditionsApplicationPlatformsInputType>;
  countries?: InputMaybe<VisibilityConditionsCountriesInputType>;
  userType?: InputMaybe<VisibilityConditionsUserTypeType>;
};

export enum VisibilityConditionsUserTypeType {
  AdminType = 'ADMIN',
  AllType = 'ALL',
  GuestType = 'GUEST',
  NoneType = 'NONE',
  UserType = 'USER'
}

export type AdminDashboardQueryVariablesType = Exact<{
  dateFrom: Scalars['DateTime']['input'];
  dateTo: Scalars['DateTime']['input'];
  compareFrom?: InputMaybe<Scalars['DateTime']['input']>;
  compareTo?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type AdminDashboardQueryType = { __typename?: 'Query', adminDashboard: { __typename?: 'AdminDashboard', dateFrom: any, dateTo: any, step: AdminDashboardStepType, current: { __typename?: 'AdminDashboardSummary', salesUSD: number, grossSalesUSD: number, refundsUSD: number, disputesUSD: number, purchasesCount: number, revenueShareUSD: number, licensesAccruedUSD: number, earnedUSD: number, issuedInvoicesUSD: number, issuedInvoicesCount: number, paidInvoicesUSD: number, paidInvoicesCount: number, paidRevenueShareUSD: number, paidLicensesUSD: number, expensesUSD: number, expensesCount: number, netIncomeUSD: number, accrualProfitUSD: number, organizationsWithSalesCount: number, newOrganizationsCount: number }, previous?: { __typename?: 'AdminDashboardSummary', salesUSD: number, grossSalesUSD: number, refundsUSD: number, disputesUSD: number, purchasesCount: number, revenueShareUSD: number, licensesAccruedUSD: number, earnedUSD: number, issuedInvoicesUSD: number, issuedInvoicesCount: number, paidInvoicesUSD: number, paidInvoicesCount: number, paidRevenueShareUSD: number, paidLicensesUSD: number, expensesUSD: number, expensesCount: number, netIncomeUSD: number, accrualProfitUSD: number, organizationsWithSalesCount: number, newOrganizationsCount: number } | null, series: Array<{ __typename?: 'AdminDashboardPoint', date: any, salesUSD: number, revenueShareUSD: number, paidInvoicesUSD: number, expensesUSD: number, netIncomeUSD: number, views: number, viewers: number }>, organizations: Array<{ __typename?: 'AdminDashboardOrganization', organizationId: string, title: string, salesUSD: number, previousSalesUSD: number, revenueShareUSD: number, paidInvoicesUSD: number, views: number }>, expensesByCategory: Array<{ __typename?: 'AdminDashboardExpenseCategory', category: InternalExpenseCategoryType, amountUSD: number, count: number }> } };

export type AdminDashboardTodayQueryVariablesType = Exact<{ [key: string]: never; }>;


export type AdminDashboardTodayQueryType = { __typename?: 'Query', adminDashboardToday: { __typename?: 'AdminDashboardToday', activeContractsCount: number, licenseContractsCount: number, licenseContractsStartingLaterCount: number, licensesMonthlyUSD: number, endingSoonCount: number, pendingRevenueShareUSD: number } };

export type AdminUnpaidInvoicesQueryVariablesType = Exact<{ [key: string]: never; }>;


export type AdminUnpaidInvoicesQueryType = { __typename?: 'Query', adminUnpaidInvoices: Array<{ __typename?: 'AdminUnpaidInvoice', id: string, organizationId: string, organizationTitle: string, invoiceNumber?: string | null, amountValue: number, amountCurrency: string, amountUSD?: number | null, invoiceDate: any, expiredAt: any, overdueDays: number, status: string }> };

export type ReplySupportRequestMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: ReplySupportRequestInputType;
}>;


export type ReplySupportRequestMutationType = { __typename?: 'Mutation', replySupportRequest: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatusType, lastMessageAt?: any | null, waitingSince?: any | null, closedAt?: any | null } };

export type SetSupportRequestStatusMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: SetSupportRequestStatusInputType;
}>;


export type SetSupportRequestStatusMutationType = { __typename?: 'Mutation', setSupportRequestStatus: { __typename?: 'SupportRequest', id: string, status: SupportRequestStatusType, waitingSince?: any | null, closedAt?: any | null } };

export type AssistantConversationShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssistantConversationShowQueryType = { __typename?: 'Query', assistantConversation?: { __typename?: 'AssistantConversation', id: string, audience: AssistantAudienceType, title?: string | null, topic?: ConversationTopicType | null, messageCount: number, lastMessageAt: any, createdAt: any, hasRequest: boolean, origin: string, originErrorCode?: string | null, knowledgeGap: boolean, knowledgeGapQuestions: Array<string>, likes: number, dislikes: number, inputTokens: number, outputTokens: number, cacheReadTokens: number, cacheWriteTokens: number, costUsd: number, model: string, utm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, messages: Array<{ __typename?: 'AssistantMessage', id: string, role: AssistantMessageRoleType, kind: AssistantMessageKindType, text: string, rating?: AssistantMessageRatingType | null, content: any, costUsd: number, durationMs: number, error?: string | null, pageUrl?: string | null, page?: any | null, cards: any, createdAt: any, attachments: Array<{ __typename?: 'AssistantAttachment', id: string, url: string, width: number, height: number }>, plan?: { __typename?: 'AssistantPlan', id: string, status: AssistantPlanStatusType, title: string } | null }> } | null };

export type AssistantConversationsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AssistantConversationsFilterInputType>;
}>;


export type AssistantConversationsListQueryType = { __typename?: 'Query', assistantConversations: { __typename?: 'AssistantConversationConnection', count: number, nodes: Array<{ __typename?: 'AssistantConversation', id: string, audience: AssistantAudienceType, title?: string | null, topic?: ConversationTopicType | null, messageCount: number, lastMessageAt: any, createdAt: any, hasRequest: boolean, knowledgeGap: boolean, likes: number, dislikes: number, costUsd: number, origin: string, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null }> } };

export type AssistantPlanShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AssistantPlanShowQueryType = { __typename?: 'Query', assistantPlan?: { __typename?: 'AssistantPlan', id: string, status: AssistantPlanStatusType, title: string, notes: Array<string>, sources: Array<string>, previews: any, conversationId: string, createdAt: any, executedAt?: any | null, finishedAt?: any | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, steps: Array<{ __typename?: 'AssistantPlanStep', index: number, operation: string, rootField: string, description: string, dangerous: boolean, removedFrom: Array<string>, status: AssistantPlanStepStatusType, input: any, result?: any | null, error?: string | null, guards: any }> } | null };

export type AssistantPlansListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AssistantPlansFilterInputType>;
}>;


export type AssistantPlansListQueryType = { __typename?: 'Query', assistantPlans: { __typename?: 'AssistantPlanConnection', count: number, nodes: Array<{ __typename?: 'AssistantPlan', id: string, status: AssistantPlanStatusType, title: string, createdAt: any, executedAt?: any | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, steps: Array<{ __typename?: 'AssistantPlanStep', index: number, status: AssistantPlanStepStatusType, dangerous: boolean }> }> } };

export type AssistantUsagesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AssistantUsagesFilterInputType>;
}>;


export type AssistantUsagesListQueryType = { __typename?: 'Query', assistantUsages: { __typename?: 'AssistantUsageConnection', count: number, nodes: Array<{ __typename?: 'AssistantUsage', id: string, audience: AssistantAudienceType, month: string, costUsd: number, messages: number, budgetUsd: number, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null }> } };

export type OpenSupportRequestsQueryVariablesType = Exact<{
  rowsPerPage: Scalars['Int']['input'];
}>;


export type OpenSupportRequestsQueryType = { __typename?: 'Query', supportRequests: { __typename?: 'SupportRequestConnection', count: number, nodes: Array<{ __typename?: 'SupportRequest', id: string, type: SupportRequestTypeType, status: SupportRequestStatusType, message: string, createdAt: any, user?: { __typename?: 'User', id: string, email?: any | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null }> } };

export type SupportRequestMessageOriginalQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportRequestMessageOriginalQueryType = { __typename?: 'Query', supportRequestMessageOriginal?: string | null };

export type SupportRequestShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SupportRequestShowQueryType = { __typename?: 'Query', supportRequest?: { __typename?: 'SupportRequest', id: string, number?: number | null, subject: string, type: SupportRequestTypeType, status: SupportRequestStatusType, message: string, details?: string | null, closedAt?: any | null, createdAt: any, lastMessageAt?: any | null, waitingSince?: any | null, conversationId: string, utm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, assignee?: { __typename?: 'User', id: string, displayName?: string | null, email?: any | null } | null, payment?: { __typename?: 'Payment', id: string, status: string, amount: { __typename?: 'Amount', value: number, currency: string } } | null, assistantMessages: Array<{ __typename?: 'AssistantMessage', id: string, role: AssistantMessageRoleType, kind: AssistantMessageKindType, text: string, createdAt: any }>, messages: Array<{ __typename?: 'SupportRequestMessage', id: string, author: SupportRequestMessageAuthorType, channel: SupportRequestMessageChannelType, body: string, internal: boolean, viaAssistant: boolean, event?: SupportRequestEventType | null, fromEmail?: string | null, skippedAttachments: number, hasOriginal: boolean, createdAt: any, staff?: { __typename?: 'User', id: string, displayName?: string | null, email?: any | null } | null, eventUser?: { __typename?: 'User', id: string, displayName?: string | null, email?: any | null } | null, attachments: Array<{ __typename?: 'SupportRequestAttachment', name: string, mimeType: string, size: number, url: string }> }> } | null };

export type SupportRequestsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<SupportRequestsFilterInputType>;
}>;


export type SupportRequestsListQueryType = { __typename?: 'Query', supportRequests: { __typename?: 'SupportRequestConnection', count: number, nodes: Array<{ __typename?: 'SupportRequest', id: string, number?: number | null, subject: string, type: SupportRequestTypeType, status: SupportRequestStatusType, createdAt: any, lastMessageAt?: any | null, user?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null }> } };

export type SupportRequestsOpenCountQueryVariablesType = Exact<{ [key: string]: never; }>;


export type SupportRequestsOpenCountQueryType = { __typename?: 'Query', supportRequestsOpenCount: number };

export type SignInMutationVariablesType = Exact<{
  input: SignInInputType;
}>;


export type SignInMutationType = { __typename?: 'Mutation', signIn: { __typename?: 'SignInOutput', token: string } };

export type SignOutMutationVariablesType = Exact<{ [key: string]: never; }>;


export type SignOutMutationType = { __typename?: 'Mutation', signOut: boolean };

export type VerifySignInMutationVariablesType = Exact<{
  token: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type VerifySignInMutationType = { __typename?: 'Mutation', verifySignIn: { __typename?: 'VerifyEmailOutput', token: string } };

export type CurrentUserQueryVariablesType = Exact<{ [key: string]: never; }>;


export type CurrentUserQueryType = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, isAdmin?: boolean | null, isSuperAdmin?: boolean | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } | null };

export type IssueContractPaymentInvoiceMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IssueContractPaymentInvoiceMutationType = { __typename?: 'Mutation', issueContractPaymentInvoice: { __typename?: 'ContractPayment', id: string, status: string, expired: boolean, invoiceUrl?: string | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null } };

export type ReissueContractPaymentInvoiceMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
}>;


export type ReissueContractPaymentInvoiceMutationType = { __typename?: 'Mutation', reissueContractPaymentInvoice: { __typename?: 'ContractPayment', id: string, status: string, expired: boolean, invoiceUrl?: string | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null } };

export type SendContractPaymentInvoiceMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SendContractPaymentInvoiceMutationType = { __typename?: 'Mutation', sendContractPaymentInvoice: { __typename?: 'ContractPayment', id: string, invoiceUrl?: string | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null } };

export type UpdateBillingSellerMutationVariablesType = Exact<{
  input: BillingSellerInputType;
}>;


export type UpdateBillingSellerMutationType = { __typename?: 'Mutation', updateBillingSeller: { __typename?: 'BillingSeller', id: string, companyName: string, registrationNumber: string, vatNumber: string, address: string, email: string, invoiceNumberPrefix: string, invoiceLanguage: string, vatNote: string, signerName: string, signerPosition: string, brandColor: string, filled: boolean, logo?: { __typename?: 'Image', id: string } | null, bankAccounts: Array<{ __typename?: 'BillingSellerBankAccount', currency: string, beneficiary: string, bankName: string, bankAddress: string, iban: string, swift: string, instructions: string }> } };

export type BillingSellerQueryVariablesType = Exact<{ [key: string]: never; }>;


export type BillingSellerQueryType = { __typename?: 'Query', billingSeller: { __typename?: 'BillingSeller', id: string, companyName: string, registrationNumber: string, vatNumber: string, address: string, email: string, invoiceNumberPrefix: string, invoiceLanguage: string, vatNote: string, signerName: string, signerPosition: string, brandColor: string, filled: boolean, logo?: { __typename?: 'Image', id: string } | null, bankAccounts: Array<{ __typename?: 'BillingSellerBankAccount', currency: string, beneficiary: string, bankName: string, bankAddress: string, iban: string, swift: string, instructions: string }> } };

export type CreateCollectionTypeMutationVariablesType = Exact<{
  input: CreateCollectionTypeInputType;
}>;


export type CreateCollectionTypeMutationType = { __typename?: 'Mutation', createCollectionType: { __typename?: 'CollectionType', id: string, title: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null } };

export type DeleteCollectionTypesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCollectionTypesMutationType = { __typename?: 'Mutation', deleteCollectionTypes: Array<{ __typename?: 'CollectionType', id: string } | null> };

export type RestoreCollectionTypesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreCollectionTypesMutationType = { __typename?: 'Mutation', restoreCollectionTypes: Array<{ __typename?: 'CollectionType', id: string } | null> };

export type UpdateCollectionTypeMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCollectionTypeInputType;
}>;


export type UpdateCollectionTypeMutationType = { __typename?: 'Mutation', updateCollectionType: { __typename?: 'CollectionType', id: string, title: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null } };

export type CollectionTypeEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CollectionTypeEditQueryType = { __typename?: 'Query', collectionType: { __typename?: 'CollectionType', id: string, title: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null } };

export type CollectionTypeShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CollectionTypeShowQueryType = { __typename?: 'Query', collectionType: { __typename?: 'CollectionType', id: string, title: string, platformId: string, organizationId: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null } };

export type CollectionTypesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CollectionTypesFilterInputType>;
}>;


export type CollectionTypesListQueryType = { __typename?: 'Query', collectionTypes: { __typename?: 'CollectionTypeConnection', count: number, nodes: Array<{ __typename?: 'CollectionType', id: string, title: string, platformId: string, showInSearch: boolean, collectionDisplayMode?: CollectionDisplayModeType | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null }> } };

export type CreateConfigMutationVariablesType = Exact<{
  input: CreateConfigInputType;
}>;


export type CreateConfigMutationType = { __typename?: 'Mutation', createConfig: { __typename?: 'Config', id: string } };

export type DeleteConfigsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteConfigsMutationType = { __typename?: 'Mutation', deleteConfigs: Array<{ __typename?: 'Config', id: string, deletedAt?: any | null } | null> };

export type RestoreConfigsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreConfigsMutationType = { __typename?: 'Mutation', restoreConfigs: Array<{ __typename?: 'Config', id: string, deletedAt?: any | null } | null> };

export type UpdateConfigMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateConfigInputType;
}>;


export type UpdateConfigMutationType = { __typename?: 'Mutation', updateConfig: { __typename?: 'Config', id: string } };

export type ConfigEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfigEditQueryType = { __typename?: 'Query', config: { __typename?: 'Config', id: string, key: string, value?: string | null } };

export type ConfigShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ConfigShowQueryType = { __typename?: 'Query', config: { __typename?: 'Config', id: string, key: string, value?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null } };

export type ConfigsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ConfigsFilterInputType>;
}>;


export type ConfigsListQueryType = { __typename?: 'Query', configs: { __typename?: 'ConfigConnection', count: number, nodes: Array<{ __typename?: 'Config', id: string, key: string, value?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null }> } };

export type DeleteContentsMutationMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteContentsMutationMutationType = { __typename?: 'Mutation', deleteContents: Array<{ __typename?: 'Content', id: string } | null> };

export type RestoreContentsMutationMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreContentsMutationMutationType = { __typename?: 'Mutation', restoreContents: Array<{ __typename?: 'Content', id: string } | null> };

export type ContentShowQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentShowQueryQueryType = { __typename?: 'Query', content: { __typename?: 'Content', id: string, title: string, description?: string | null, type: ContentTypeType, processingStatus: ContentProcessingStatusType, publishAt?: any | null, accessStartAt?: any | null, hideInGeneralLists: boolean, onlyUsers: boolean, ageRestrictions: number, totalViews: number, duration?: number | null, transcodingError?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, tags: Array<{ __typename?: 'Tag', id: string, title: string }>, preview?: { __typename?: 'Image', id: string, url: any } | null, verticalPreview?: { __typename?: 'Image', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, video?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null, readyToStream: boolean, duration?: number | null, transcodingError?: string | null } | null, pendingVideo?: { __typename?: 'Video', id: string, uid: string, fileName?: string | null } | null, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, liveConnected: boolean, startAt?: any | null, finishAt?: any | null, lastPublishAt?: any | null, lastPublishFinishAt?: any | null, enableRecord: boolean, autoPublishRecord: boolean, isChatEnabled: boolean, dvrEnabled: boolean, recordContentId?: string | null, cfAccountId: string, liveInputId: string, lastError?: { __typename?: 'StreamError', code: string, message: string } | null, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, lastError?: { __typename?: 'StreamError', message: string } | null } | null, entrypoint?: { __typename?: 'StreamEntrypoint', id: string, title: string } | null } | null } };

export type ContentsListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type ContentsListQueryQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, title: string, type: ContentTypeType, processingStatus: ContentProcessingStatusType, publishAt?: any | null, createdAt: any, deletedAt?: any | null, preview?: { __typename?: 'Image', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null }> } };

export type SetContractPaymentStatusMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  paidAt?: InputMaybe<Scalars['DateTime']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetContractPaymentStatusMutationType = { __typename?: 'Mutation', setContractPaymentStatus: { __typename?: 'ContractPayment', id: string, status: string, expired: boolean, paidAt?: any | null, note?: string | null } };

export type UpdateContractPaymentNoteMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateContractPaymentNoteInputType;
}>;


export type UpdateContractPaymentNoteMutationType = { __typename?: 'Mutation', updateContractPaymentNote: { __typename?: 'ContractPayment', id: string, note?: string | null } };

export type ContractPaymentShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractPaymentShowQueryType = { __typename?: 'Query', contractPayment: { __typename?: 'ContractPayment', id: string, contractId: string, organizationId: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, note?: string | null, invoiceUrl?: string | null, contract?: { __typename?: 'Contract', id: string, title: string, currency: string, invoiceCurrency?: string | null } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, exchangeRate?: { __typename?: 'ExchangeRateSnapshot', rate: number, date: any, source: string } | null, invoiceAmount?: { __typename?: 'Amount', value: number, currency: string } | null, invoiceExchangeRate?: { __typename?: 'ExchangeRateSnapshot', rate: number, date: any, source: string } | null, lines: Array<{ __typename?: 'ContractPaymentLine', itemType: string, title: string, reportId?: string | null, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, report?: { __typename?: 'RevenueShareReport', id: string, period: string, status: string } | null }> } };

export type ContractPaymentsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContractPaymentsFilterInputType>;
}>;


export type ContractPaymentsListQueryType = { __typename?: 'Query', contractPayments: { __typename?: 'ContractPaymentConnection', count: number, nodes: Array<{ __typename?: 'ContractPayment', id: string, contractId: string, organizationId: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, note?: string | null, invoiceUrl?: string | null, contract?: { __typename?: 'Contract', id: string, title: string, currency: string } | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, exchangeRate?: { __typename?: 'ExchangeRateSnapshot', rate: number, date: any, source: string } | null, invoiceAmount?: { __typename?: 'Amount', value: number, currency: string } | null, invoiceExchangeRate?: { __typename?: 'ExchangeRateSnapshot', rate: number, date: any, source: string } | null, lines: Array<{ __typename?: 'ContractPaymentLine', itemType: string, title: string, reportId?: string | null, amount: { __typename?: 'Amount', value: number, currency: string }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string } | null, report?: { __typename?: 'RevenueShareReport', id: string, period: string, status: string } | null }> }> } };

export type CancelContractMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelContractMutationType = { __typename?: 'Mutation', cancelContract: { __typename?: 'Contract', id: string, status: string, canceledAt?: any | null } };

export type CreateContractMutationVariablesType = Exact<{
  input: CreateContractInputType;
}>;


export type CreateContractMutationType = { __typename?: 'Mutation', createContract: { __typename?: 'Contract', id: string, title: string, status: string } };

export type UpdateContractMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateContractInputType;
}>;


export type UpdateContractMutationType = { __typename?: 'Mutation', updateContract: { __typename?: 'Contract', id: string, title: string, status: string } };

export type ContractDetailsQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractDetailsQueryType = { __typename?: 'Query', contract: { __typename?: 'Contract', id: string, organizationId: string, title: string, currency: string, invoiceCurrency?: string | null, status: string, dateFrom: any, dateTo?: any | null, billingPeriodMonths: number, paymentPeriodType: string, paidPeriodDays: number, note?: string | null, canceledAt?: any | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, items: Array<{ __typename?: 'ContractItem', type: string, title: string, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> }, contractPayments: { __typename?: 'ContractPaymentConnection', count: number, nodes: Array<{ __typename?: 'ContractPayment', id: string, periodFrom: any, periodTo: any, invoiceDate: any, expiredAt: any, paidAt?: any | null, status: string, expired: boolean, amount: { __typename?: 'Amount', value: number, currency: string }, invoice?: { __typename?: 'ContractPaymentInvoice', number: string, issuedAt: any, sentAt?: any | null, sentTo: Array<string>, previousNumbers: Array<{ __typename?: 'ContractPaymentInvoicePreviousNumber', number: string, issuedAt: any, reason: string }> } | null }> } };

export type ContractShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContractShowQueryType = { __typename?: 'Query', contract: { __typename?: 'Contract', id: string, organizationId: string, title: string, currency: string, invoiceCurrency?: string | null, status: string, dateFrom: any, dateTo?: any | null, billingPeriodMonths: number, paymentPeriodType: string, paidPeriodDays: number, note?: string | null, canceledAt?: any | null, items: Array<{ __typename?: 'ContractItem', type: string, title: string, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> } };

export type ContractsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContractsFilterInputType>;
}>;


export type ContractsListQueryType = { __typename?: 'Query', contracts: { __typename?: 'ContractConnection', count: number, nodes: Array<{ __typename?: 'Contract', id: string, organizationId: string, title: string, currency: string, invoiceCurrency?: string | null, status: string, dateFrom: any, dateTo?: any | null, billingPeriodMonths: number, paymentPeriodType: string, paidPeriodDays: number, canceledAt?: any | null, createdAt: any, organization?: { __typename?: 'Organization', id: string, title: string } | null, items: Array<{ __typename?: 'ContractItem', type: string, title: string, amount?: { __typename?: 'Amount', value: number, currency: string } | null }> }> } };

export type DisputesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type DisputesListQueryType = { __typename?: 'Query', disputes: { __typename?: 'DisputeConnection', count: number, nodes: Array<{ __typename?: 'Dispute', id: string, organizationId: string, status: string, createdAt: any, closedAt?: any | null, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, ottkitFeeAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organizationAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organization: { __typename?: 'Organization', title: string }, payment?: { __typename?: 'Payment', userId: string, buyerEmail?: string | null, provider: string, product?: { __typename?: 'Product', title: string, type: ProductTypeType } | null } | null }> } };

export type CreateDocumentMutationMutationVariablesType = Exact<{
  input: CreateDocumentInputType;
}>;


export type CreateDocumentMutationMutationType = { __typename?: 'Mutation', createDocument: { __typename?: 'Document', id: string, title: string, slug: string, type: DocumentTypeType } };

export type DeleteDocumentsMutationMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteDocumentsMutationMutationType = { __typename?: 'Mutation', deleteDocuments: Array<{ __typename?: 'Document', id: string } | null> };

export type RestoreDocumentsMutationMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreDocumentsMutationMutationType = { __typename?: 'Mutation', restoreDocuments: Array<{ __typename?: 'Document', id: string } | null> };

export type UpdateDocumentMutationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateDocumentInputType;
}>;


export type UpdateDocumentMutationMutationType = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, title: string, slug: string, type: DocumentTypeType, isPublished: boolean } };

export type DocumentEditQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentEditQueryQueryType = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title: string, text: string, slug: string, type: DocumentTypeType, isPublished: boolean, date: any, platform?: { __typename?: 'Platform', id: string, title: string } | null, language?: { __typename?: 'Language', id: string, title: string } | null } };

export type DocumentShowQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentShowQueryQueryType = { __typename?: 'Query', document: { __typename?: 'Document', id: string, title: string, text: string, slug: string, type: DocumentTypeType, isPublished: boolean, version: DocumentVersionType, date: any, versionIds: Array<string>, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, versions: Array<{ __typename?: 'Document', id: string, version: DocumentVersionType, date: any, createdAt: any }>, platform?: { __typename?: 'Platform', id: string, title: string } | null, language?: { __typename?: 'Language', id: string, title: string } | null } };

export type DocumentsListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DocumentsFilterInputType>;
}>;


export type DocumentsListQueryQueryType = { __typename?: 'Query', documents: { __typename?: 'DocumentConnection', count: number, nodes: Array<{ __typename?: 'Document', id: string, title: string, slug: string, type: DocumentTypeType, isPublished: boolean, version: DocumentVersionType, createdAt: any, deletedAt?: any | null, deleted?: boolean | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, language?: { __typename?: 'Language', id: string, title: string } | null }> } };

export type CreateInternalExpenseMutationVariablesType = Exact<{
  input: CreateInternalExpenseInputType;
}>;


export type CreateInternalExpenseMutationType = { __typename?: 'Mutation', createInternalExpense: { __typename?: 'InternalExpense', id: string } };

export type DeleteInternalExpensesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteInternalExpensesMutationType = { __typename?: 'Mutation', deleteInternalExpenses: Array<{ __typename?: 'InternalExpense', id: string, deletedAt?: any | null } | null> };

export type RestoreInternalExpensesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreInternalExpensesMutationType = { __typename?: 'Mutation', restoreInternalExpenses: Array<{ __typename?: 'InternalExpense', id: string, deletedAt?: any | null } | null> };

export type UpdateInternalExpenseMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateInternalExpenseInputType;
}>;


export type UpdateInternalExpenseMutationType = { __typename?: 'Mutation', updateInternalExpense: { __typename?: 'InternalExpense', id: string } };

export type InternalExpenseEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalExpenseEditQueryType = { __typename?: 'Query', internalExpense: { __typename?: 'InternalExpense', id: string, spentAt: any, category: InternalExpenseCategoryType, title: string, vendor?: string | null, note?: string | null, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } } };

export type InternalExpensesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<InternalExpensesFilterInputType>;
}>;


export type InternalExpensesListQueryType = { __typename?: 'Query', internalExpenses: { __typename?: 'InternalExpenseConnection', count: number, nodes: Array<{ __typename?: 'InternalExpense', id: string, spentAt: any, category: InternalExpenseCategoryType, title: string, vendor?: string | null, note?: string | null, creatorId: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } }>, totalAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } } };

export type CreateLanguageMutationVariablesType = Exact<{
  input: CreateLanguageInputType;
}>;


export type CreateLanguageMutationType = { __typename?: 'Mutation', createLanguage: { __typename?: 'Language', id: string } };

export type DeleteLanguagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteLanguagesMutationType = { __typename?: 'Mutation', deleteLanguages: Array<{ __typename?: 'Language', id: string, deletedAt?: any | null } | null> };

export type RestoreLanguagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreLanguagesMutationType = { __typename?: 'Mutation', restoreLanguages: Array<{ __typename?: 'Language', id: string, deletedAt?: any | null } | null> };

export type UpdateLanguageMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateLanguageInputType;
}>;


export type UpdateLanguageMutationType = { __typename?: 'Mutation', updateLanguage: { __typename?: 'Language', id: string } };

export type LanguageEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LanguageEditQueryType = { __typename?: 'Query', language: { __typename?: 'Language', id: string, title: string, native: string, code: string, translation: boolean } };

export type LanguageShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LanguageShowQueryType = { __typename?: 'Query', language: { __typename?: 'Language', id: string, title: string, native: string, code: string, translation: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null } };

export type LanguagesAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type LanguagesAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type LanguagesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<LanguagesFilterInputType>;
}>;


export type LanguagesListQueryType = { __typename?: 'Query', languages: { __typename?: 'LanguageConnection', count: number, nodes: Array<{ __typename?: 'Language', id: string, title: string, native: string, code: string, translation: boolean, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null }> } };

export type CreateMailerConfigMutationVariablesType = Exact<{
  input: CreateMailerConfigInputType;
}>;


export type CreateMailerConfigMutationType = { __typename?: 'Mutation', createMailerConfig: { __typename?: 'MailerConfig', id: string } };

export type DeleteMailerConfigsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteMailerConfigsMutationType = { __typename?: 'Mutation', deleteMailerConfigs: Array<{ __typename?: 'MailerConfig', id: string, deletedAt?: any | null } | null> };

export type RestoreMailerConfigsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreMailerConfigsMutationType = { __typename?: 'Mutation', restoreMailerConfigs: Array<{ __typename?: 'MailerConfig', id: string, deletedAt?: any | null } | null> };

export type TestMailerConfigMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TestMailerConfigMutationType = { __typename?: 'Mutation', testMailerConfig: boolean };

export type UpdateMailerConfigMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateMailerConfigInputType;
}>;


export type UpdateMailerConfigMutationType = { __typename?: 'Mutation', updateMailerConfig: { __typename?: 'MailerConfig', id: string } };

export type MailerConfigEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MailerConfigEditQueryType = { __typename?: 'Query', mailerConfig: { __typename?: 'MailerConfig', id: string, title: string, from: string, siteUrl: any, siteName: string, siteEmail: string, logo?: { __typename?: 'Image', id: string, url: any } | null } };

export type MailerConfigShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MailerConfigShowQueryType = { __typename?: 'Query', mailerConfig: { __typename?: 'MailerConfig', id: string, title: string, from: string, siteUrl: any, siteName: string, siteEmail: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, logo?: { __typename?: 'Image', id: string, url: any } | null } };

export type MailerConfigsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<MailerConfigsFilterInputType>;
}>;


export type MailerConfigsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type MailerConfigsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MailerConfigsFilterInputType>;
}>;


export type MailerConfigsListQueryType = { __typename?: 'Query', mailerConfigs: { __typename?: 'MailerConfigConnection', count: number, nodes: Array<{ __typename?: 'MailerConfig', id: string, title: string, from: string, siteUrl: any, siteName: string, siteEmail: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, logo?: { __typename?: 'Image', id: string, url: any } | null }> } };

export type MigrateMutationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MigrateMutationMutationType = { __typename?: 'Mutation', migrate: string };

export type MigrationLogsQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MigrationLogsFilterInputType>;
}>;


export type MigrationLogsQueryQueryType = { __typename?: 'Query', migrationLogs: { __typename?: 'MigrationLogConnection', count: number, nodes: Array<{ __typename?: 'MigrationLog', id: string, migrationId: string, message: string, createdAt: any }> } };

export type MigrationShowQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MigrationShowQueryQueryType = { __typename?: 'Query', migration: { __typename?: 'Migration', id: string, title: string, status?: string | null, error?: string | null, attemptsMade?: number | null, lastRunAt?: any | null, createdAt: any } };

export type MigrationsListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<MigrationsFilterInputType>;
}>;


export type MigrationsListQueryQueryType = { __typename?: 'Query', migrations: { __typename?: 'MigrationConnection', count: number, nodes: Array<{ __typename?: 'Migration', id: string, title: string, status?: string | null, error?: string | null, attemptsMade?: number | null, lastRunAt?: any | null, createdAt: any }> } };

export type MigrationUpdatedSubscriptionSubscriptionVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MigrationUpdatedSubscriptionSubscriptionType = { __typename?: 'Subscription', migrationUpdated: { __typename?: 'Migration', id: string, title: string, status?: string | null, error?: string | null, attemptsMade?: number | null, lastRunAt?: any | null, createdAt: any } };

export type NewMigrationLogsSubscriptionSubscriptionVariablesType = Exact<{
  migrationId: Scalars['ID']['input'];
}>;


export type NewMigrationLogsSubscriptionSubscriptionType = { __typename?: 'Subscription', newMigrationLogs: { __typename?: 'MigrationLog', id: string, migrationId: string, message: string, createdAt: any } };

export type CreateOrganizationUserMutationVariablesType = Exact<{
  input: CreateOrganizationUserInputType;
}>;


export type CreateOrganizationUserMutationType = { __typename?: 'Mutation', createOrganizationUser: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, createdAt: any } };

export type DeleteOrganizationUsersMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteOrganizationUsersMutationType = { __typename?: 'Mutation', deleteOrganizationUsers: Array<{ __typename?: 'OrganizationUser', id: string, deleted?: boolean | null, deletedAt?: any | null } | null> };

export type RestoreOrganizationUsersMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreOrganizationUsersMutationType = { __typename?: 'Mutation', restoreOrganizationUsers: Array<{ __typename?: 'OrganizationUser', id: string, deleted?: boolean | null, updatedAt: any } | null> };

export type UpdateOrganizationUserRolesMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  roles: Array<OrganizationRoleType> | OrganizationRoleType;
}>;


export type UpdateOrganizationUserRolesMutationType = { __typename?: 'Mutation', updateOrganizationUserRoles: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType> } };

export type OrganizationUserShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationUserShowQueryType = { __typename?: 'Query', organizationUser: { __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, user: { __typename?: 'User', id: string, email?: any | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, displayName?: string | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } } };

export type OrganizationUsersListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationUsersFilterInputType>;
}>;


export type OrganizationUsersListQueryType = { __typename?: 'Query', organizationUsers: { __typename?: 'OrganizationUserConnection', count: number, nodes: Array<{ __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, createdAt: any, user: { __typename?: 'User', id: string, email?: any | null, firstName?: string | null, lastName?: string | null, displayName?: string | null } }> } };

export type UserOrganizationsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationUsersFilterInputType>;
}>;


export type UserOrganizationsListQueryType = { __typename?: 'Query', organizationUsers: { __typename?: 'OrganizationUserConnection', count: number, nodes: Array<{ __typename?: 'OrganizationUser', id: string, roles: Array<OrganizationRoleType>, createdAt: any, organization: { __typename?: 'Organization', id: string, title: string } }> } };

export type CreateOrganizationMutationVariablesType = Exact<{
  input: CreateOrganizationInputType;
}>;


export type CreateOrganizationMutationType = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string, createdAt: any } };

export type DeleteOrganizationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteOrganizationsMutationType = { __typename?: 'Mutation', deleteOrganizations: Array<{ __typename?: 'Organization', id: string, deleted?: boolean | null, deletedAt?: any | null } | null> };

export type RestoreOrganizationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreOrganizationsMutationType = { __typename?: 'Mutation', restoreOrganizations: Array<{ __typename?: 'Organization', id: string, deleted?: boolean | null, updatedAt: any } | null> };

export type UpdateOrganizationBillingRequisitesMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: OrganizationBillingRequisitesInputType;
}>;


export type UpdateOrganizationBillingRequisitesMutationType = { __typename?: 'Mutation', updateOrganizationBillingRequisites: { __typename?: 'Organization', id: string, billingRequisites: { __typename?: 'OrganizationBillingRequisites', companyName: string, registrationNumber: string, vatNumber: string, address: string, contactName: string, contactEmail?: string | null, invoiceEmails: Array<string>, contractNumber: string, contractDate?: any | null, filled: boolean } } };

export type UpdateOrganizationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOrganizationInputType;
}>;


export type UpdateOrganizationMutationType = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, updatedAt: any } };

export type OrganizationBillingRequisitesQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationBillingRequisitesQueryType = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, title: string, billingRequisites: { __typename?: 'OrganizationBillingRequisites', companyName: string, registrationNumber: string, vatNumber: string, address: string, contactName: string, contactEmail?: string | null, invoiceEmails: Array<string>, contractNumber: string, contractDate?: any | null, filled: boolean } } };

export type OrganizationEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationEditQueryType = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, title: string, altNames?: Array<string> | null, description?: string | null, slug: string, website?: string | null, status: OrganizationStatusType, currency: PaymentCurrencyType, logo?: { __typename?: 'Avatar', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, feeSettings: { __typename?: 'OrganizationFeeSettings', feeType: FeeTypeType, percentageFee: number, providerFeePayer: ProviderFeePayerType, fixedFeeAmount: { __typename?: 'FixedFeeAmount', value: number, currency: PaymentCurrencyType } }, assistant?: { __typename?: 'OrganizationAssistantSettings', enabled: boolean, model?: string | null, monthlyBudgetUsd?: number | null } | null } };

export type OrganizationShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationShowQueryType = { __typename?: 'Query', organization: { __typename?: 'Organization', id: string, title: string, altNames?: Array<string> | null, description?: string | null, slug: string, website?: string | null, status: OrganizationStatusType, currency: PaymentCurrencyType, sudoUrl?: any | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, logo?: { __typename?: 'Avatar', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, feeSettings: { __typename?: 'OrganizationFeeSettings', feeType: FeeTypeType, percentageFee: number, providerFeePayer: ProviderFeePayerType, fixedFeeAmount: { __typename?: 'FixedFeeAmount', value: number, currency: PaymentCurrencyType } } } };

export type OrganizationsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OrganizationsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type OrganizationsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<OrganizationsFilterInputType>;
}>;


export type OrganizationsListQueryType = { __typename?: 'Query', organizations: { __typename?: 'OrganizationConnection', count: number, nodes: Array<{ __typename?: 'Organization', id: string, title: string, altNames?: Array<string> | null, description?: string | null, slug: string, website?: string | null, status: OrganizationStatusType, createdAt: any, logo?: { __typename?: 'Avatar', id: string, url: any } | null }> } };

export type PaymentShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PaymentShowQueryType = { __typename?: 'Query', payment?: { __typename?: 'Payment', id: string, platformId: string, organizationId: string, userId: string, status: string, provider: string, providerPaymentId?: string | null, providerTransactionId?: string | null, recurrent: boolean, period: number, promocodeId?: string | null, country?: string | null, city?: string | null, buyerEmail?: string | null, createdAt: any, updatedAt: any, metadata?: any | null, providerPaymentData?: any | null, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, amountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, providerFeeAmount?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, ottkitFeeAmount?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, feeAmount?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, organizationAmount?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, organizationAmountInOrganizationCurrency?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, feeSettings?: { __typename?: 'OrganizationFeeSettings', feeType: FeeTypeType, percentageFee: number, providerFeePayer: ProviderFeePayerType, fixedFeeAmount: { __typename?: 'FixedFeeAmount', value: number, currency: PaymentCurrencyType } } | null, organization: { __typename?: 'Organization', id: string, title: string }, platform?: { __typename?: 'Platform', id: string, title: string } | null, buyer?: { __typename?: 'User', id: string, email?: any | null, displayName?: string | null } | null, purchase?: { __typename?: 'ProductPurchase', id: string, type: string, startAt: any, expiredAt: any } | null, product?: { __typename?: 'Product', id: string, title: string, type: ProductTypeType } | null } | null };

export type PaymentsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type PaymentsListQueryType = { __typename?: 'Query', payments: { __typename?: 'PaymentConnection', count: number, nodes: Array<{ __typename?: 'Payment', id: string, platformId: string, organizationId: string, status: string, provider: string, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, ottkitFeeAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organizationAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organization: { __typename?: 'Organization', title: string } }> } };

export type CreatePlatformMenuItemMutationVariablesType = Exact<{
  input: CreatePlatformMenuItemInputType;
}>;


export type CreatePlatformMenuItemMutationType = { __typename?: 'Mutation', createPlatformMenuItem: { __typename?: 'PlatformMenuItem', id: string, label: string } };

export type CreatePlatformMutationVariablesType = Exact<{
  input: CreatePlatformInputType;
}>;


export type CreatePlatformMutationType = { __typename?: 'Mutation', createPlatform: { __typename?: 'Platform', id: string, createdAt: any } };

export type CreatePlatformPageMutationVariablesType = Exact<{
  input: CreatePlatformPageInputType;
}>;


export type CreatePlatformPageMutationType = { __typename?: 'Mutation', createPlatformPage: { __typename?: 'PlatformPage', id: string, title: string, path: string } };

export type DeletePlatformMenuItemsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformMenuItemsMutationType = { __typename?: 'Mutation', deletePlatformMenuItems: Array<{ __typename?: 'PlatformMenuItem', id: string } | null> };

export type DeletePlatformPagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformPagesMutationType = { __typename?: 'Mutation', deletePlatformPages: Array<{ __typename?: 'PlatformPage', id: string } | null> };

export type DeletePlatformsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeletePlatformsMutationType = { __typename?: 'Mutation', deletePlatforms: Array<{ __typename?: 'Platform', id: string } | null> };

export type RestorePlatformMenuItemsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestorePlatformMenuItemsMutationType = { __typename?: 'Mutation', restorePlatformMenuItems: Array<{ __typename?: 'PlatformMenuItem', id: string } | null> };

export type RestorePlatformPagesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestorePlatformPagesMutationType = { __typename?: 'Mutation', restorePlatformPages: Array<{ __typename?: 'PlatformPage', id: string } | null> };

export type RestorePlatformsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestorePlatformsMutationType = { __typename?: 'Mutation', restorePlatforms: Array<{ __typename?: 'Platform', id: string } | null> };

export type SetPlatformStripeBillingModeMutationVariablesType = Exact<{
  platformId: Scalars['ID']['input'];
  mode: StripeBillingModeType;
}>;


export type SetPlatformStripeBillingModeMutationType = { __typename?: 'Mutation', setPlatformStripeBillingMode: { __typename?: 'Platform', id: string, stripeBillingMode: StripeBillingModeType } };

export type UpdatePlatformBunnySettingsMutationVariablesType = Exact<{
  platformId: Scalars['ID']['input'];
  input: UpdateBunnySettingsInputType;
}>;


export type UpdatePlatformBunnySettingsMutationType = { __typename?: 'Mutation', updatePlatformBunnySettings: { __typename?: 'Platform', id: string, bunnySettings?: { __typename?: 'PlatformBunnySettings', libraryId: string, cdnHostname: string, apiKeyMask: string, connectedAt?: any | null } | null } };

export type UpdatePlatformMenuItemMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformMenuItemInputType;
}>;


export type UpdatePlatformMenuItemMutationType = { __typename?: 'Mutation', updatePlatformMenuItem: { __typename?: 'PlatformMenuItem', id: string, label: string } };

export type UpdatePlatformMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformInputType;
}>;


export type UpdatePlatformMutationType = { __typename?: 'Mutation', updatePlatform: { __typename?: 'Platform', id: string, updatedAt: any } };

export type UpdatePlatformPageMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePlatformPageInputType;
}>;


export type UpdatePlatformPageMutationType = { __typename?: 'Mutation', updatePlatformPage: { __typename?: 'PlatformPage', id: string, title: string, path: string } };

export type UpdatePlatformStreamingSettingsMutationVariablesType = Exact<{
  platformId: Scalars['ID']['input'];
  input: UpdateStreamingSettingsInputType;
}>;


export type UpdatePlatformStreamingSettingsMutationType = { __typename?: 'Mutation', updatePlatformStreamingSettings: { __typename?: 'Platform', id: string, streamingSettings?: { __typename?: 'PlatformStreamingSettings', accountId: string, apiTokenMask: string, connectedAt?: any | null } | null } };

export type PlatformEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformEditQueryType = { __typename?: 'Query', platform: { __typename?: 'Platform', id: string, title: string, slug: string, description?: string | null, status: PlatformStatusType, host?: string | null, videoProvider?: VideoProviderType | null, mailerConfigId?: string | null, gaId?: string | null, defaultRowSize?: number | null, googleSiteVerification?: string | null, privacyPolicyUrl?: any | null, termsOfServiceUrl?: any | null, refundPolicyUrl?: any | null, customHTML?: string | null, customHead?: string | null, supportEmail?: string | null, showSupportEmail?: boolean | null, showTerms?: boolean | null, showCookieBanner?: boolean | null, acceptTermsOfServiceOnSignIn?: boolean | null, hideableHeader?: boolean | null, isLikesEnabled?: boolean | null, isFavoritesEnabled?: boolean | null, isFeaturedVideosEnabled?: boolean | null, isVideoChatEnabled?: boolean | null, isStreamChatEnabled?: boolean | null, features: Array<PlatformFeatureType>, marketingMonthlyQuota?: number | null, marketingJourneyEntriesPerDay?: number | null, isLiveReactionsEnabled?: boolean | null, parallelPremiumViewLimit?: number | null, organizationId?: string | null, languageId?: string | null, logo?: { __typename?: 'Avatar', id: string } | null, favicon?: { __typename?: 'Avatar', id: string } | null, theme?: { __typename?: 'PlatformTheme', palette?: { __typename?: 'PlatformThemePalette', type: PlatformThemePaletteTypeType, primary?: string | null, secondary?: string | null, backgroundColor?: string | null } | null, typography?: { __typename?: 'PlatformThemeTypography', fontFamily?: string | null, headingFontFamily?: string | null } | null } | null, footer?: { __typename?: 'PlatformFooter', title?: string | null, subtitle?: string | null, social: Array<{ __typename?: 'PlatformSocial', type: PlatformSocialTypeType, link: any }> } | null, customTerms: Array<{ __typename?: 'PlatformCustomTerm', label: string, url: any }>, clientFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }>, language?: { __typename?: 'Language', id: string, code: string, title: string } | null, assistant?: { __typename?: 'PlatformAssistantSettings', enabled: boolean, name?: string | null, notes?: string | null, model?: string | null, monthlyBudgetUsd?: number | null, dailyMessagesPerViewer?: number | null, avatar?: { __typename?: 'Avatar', id: string } | null } | null } };

export type PlatformMenuItemShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformMenuItemShowQueryType = { __typename?: 'Query', platformMenuItem: { __typename?: 'PlatformMenuItem', id: string, label: string, type: PlatformMenuItemTypeType, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetUrl?: any | null, mobileIcon?: string | null, index: number, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, publishAt?: any | null, createdAt: any, updatedAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null, platform: { __typename?: 'Platform', id: string, title: string, slug: string }, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } }, items: Array<{ __typename?: 'PlatformMenuItemDialogItem', id?: string | null, title?: string | null, subItems: Array<{ __typename?: 'PlatformMenuItemDialogSubItem', id?: string | null, title?: string | null, subtitle?: string | null, href?: string | null, mobileIcon?: string | null, icon?: { __typename?: 'Avatar', id: string, url: any } | null }> }> } };

export type PlatformMenuItemsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformMenuItemsFilterInputType>;
}>;


export type PlatformMenuItemsListQueryType = { __typename?: 'Query', platformMenuItems: { __typename?: 'PlatformMenuItemConnection', count: number, nodes: Array<{ __typename?: 'PlatformMenuItem', id: string, index: number, mobileIcon?: string | null, label: string, type: PlatformMenuItemTypeType, linkType: PlatformMenuItemLinkTypeType, href?: string | null, targetType?: LinkTargetTypeType | null, targetId?: string | null, targetTitle?: string | null, targetUrl?: any | null, publishAt?: any | null, createdAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null, platform: { __typename?: 'Platform', id: string, title: string, slug: string }, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type PlatformPageShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformPageShowQueryType = { __typename?: 'Query', platformPage: { __typename?: 'PlatformPage', id: string, isHomepage: boolean, countryCodes: Array<string>, title: string, description?: string | null, path: string, publishAt?: any | null, createdAt: any, updatedAt: any, image?: { __typename?: 'Banner', id: string, url: any } | null, platform: { __typename?: 'Platform', id: string, title: string, slug: string }, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } }, blocks: Array<{ __typename?: 'PlatformPageBlock', id: string, component: PlatformPageBlockTypeType, props: any, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type PlatformPagesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformPagesFilterInputType>;
}>;


export type PlatformPagesListQueryType = { __typename?: 'Query', platformPages: { __typename?: 'PlatformPageConnection', count: number, nodes: Array<{ __typename?: 'PlatformPage', id: string, title: string, path: string, isHomepage: boolean, countryCodes: Array<string>, description?: string | null, publishAt?: any | null, createdAt: any, image?: { __typename?: 'Banner', id: string, url: any } | null, platform: { __typename?: 'Platform', id: string, title: string, slug: string }, visibilityConditions: { __typename?: 'VisibilityConditions', userType?: VisibilityConditionsUserTypeType | null, countries: { __typename?: 'VisibilityConditionsCountries', type: VisibilityConditionsCountriesTypeType, countryCodes: Array<string> }, applicationPlatforms: { __typename?: 'VisibilityConditionsApplicationPlatforms', type: VisibilityConditionsApplicationPlatformTypeType, platforms: Array<ApplicationPlatformType> } } }> } };

export type PlatformShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlatformShowQueryType = { __typename?: 'Query', platform: { __typename?: 'Platform', id: string, title: string, slug: string, description?: string | null, status: PlatformStatusType, published: boolean, host?: string | null, slugHost: string, slugUrl: any, url: any, gaId?: string | null, defaultRowSize?: number | null, googleSiteVerification?: string | null, customHTML?: string | null, customHead?: string | null, supportEmail?: string | null, showSupportEmail?: boolean | null, showTerms?: boolean | null, showCookieBanner?: boolean | null, hideableHeader?: boolean | null, isLikesEnabled?: boolean | null, isFavoritesEnabled?: boolean | null, isFeaturedVideosEnabled?: boolean | null, isVideoChatEnabled?: boolean | null, isStreamChatEnabled?: boolean | null, organizationId?: string | null, sudoUrl?: any | null, videoProvider?: VideoProviderType | null, effectiveVideoProvider: VideoProviderType, streamingAvailable: boolean, stripeBillingMode: StripeBillingModeType, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, logo?: { __typename?: 'Avatar', id: string, url: any } | null, favicon?: { __typename?: 'Avatar', id: string, url: any } | null, theme?: { __typename?: 'PlatformTheme', palette?: { __typename?: 'PlatformThemePalette', type: PlatformThemePaletteTypeType, primary?: string | null, secondary?: string | null, backgroundColor?: string | null } | null, typography?: { __typename?: 'PlatformThemeTypography', fontFamily?: string | null, headingFontFamily?: string | null } | null } | null, footer?: { __typename?: 'PlatformFooter', title?: string | null, subtitle?: string | null, social: Array<{ __typename?: 'PlatformSocial', type: PlatformSocialTypeType, link: any }> } | null, customTerms: Array<{ __typename?: 'PlatformCustomTerm', label: string, url: any }>, clientFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }>, organization?: { __typename?: 'Organization', id: string, title: string } | null, streamingSettings?: { __typename?: 'PlatformStreamingSettings', accountId: string, apiTokenMask: string, connectedAt?: any | null } | null, bunnySettings?: { __typename?: 'PlatformBunnySettings', libraryId: string, cdnHostname: string, apiKeyMask: string, connectedAt?: any | null } | null } };

export type PlatformsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<PlatformsFilterInputType>;
}>;


export type PlatformsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', value: Array<{ __typename?: 'AutocompleteOptionWithID', label: string, value: string } | null>, options: Array<{ __typename?: 'AutocompleteOptionWithID', label: string, value: string } | null> } };

export type PlatformsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PlatformsFilterInputType>;
}>;


export type PlatformsListQueryType = { __typename?: 'Query', platforms: { __typename?: 'PlatformConnection', count: number, nodes: Array<{ __typename?: 'Platform', id: string, title: string, slug: string, description?: string | null, status: PlatformStatusType, published: boolean, host?: string | null, slugHost: string, slugUrl: any, url: any, createdAt: any, logo?: { __typename?: 'Avatar', id: string, url: any } | null }> } };

export type PlatformsSearchAutocompleteQueryVariablesType = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlatformsSearchAutocompleteQueryType = { __typename?: 'Query', platforms: { __typename?: 'PlatformConnection', nodes: Array<{ __typename?: 'Platform', id: string, title: string }> } };

export type TerminateProductPurchaseMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TerminateProductPurchaseMutationType = { __typename?: 'Mutation', terminateProductPurchase: { __typename?: 'ProductPurchase', id: string, startAt: any, expiredAt: any } };

export type UpdateProductPurchaseMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProductPurchaseInputType;
}>;


export type UpdateProductPurchaseMutationType = { __typename?: 'Mutation', updateProductPurchase: { __typename?: 'ProductPurchase', id: string, startAt: any, expiredAt: any, subscription?: { __typename?: 'ProductSubscription', id: string, renewSubscription: boolean } | null } };

export type ProductPurchasesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type ProductPurchasesListQueryType = { __typename?: 'Query', productPurchases: { __typename?: 'ProductPurchaseConnection', count: number, nodes: Array<{ __typename?: 'ProductPurchase', id: string, platformId: string, organizationId: string, type: string, startAt: any, expiredAt: any, refunded: boolean, disputed: boolean, buyerEmail?: string | null, subscriptionId?: string | null, organization: { __typename?: 'Organization', title: string }, product: { __typename?: 'Product', title: string }, payment?: { __typename?: 'Payment', userId: string, amount: { __typename?: 'Amount', value: number, currency: string } } | null, subscription?: { __typename?: 'ProductSubscription', id: string, status: string, provider?: string | null, renewSubscription: boolean, autoRenewEditable: boolean, billingCyclesComplete: number } | null }> } };

export type CleanQueueMutationMutationVariablesType = Exact<{
  queueName: Scalars['String']['input'];
  status: Scalars['String']['input'];
}>;


export type CleanQueueMutationMutationType = { __typename?: 'Mutation', cleanQueue: { __typename?: 'Queue', id: string, name: string, jobCounts: { __typename?: 'QueueJobCounts', waiting: number, active: number, completed: number, failed: number, delayed: number } } };

export type DeleteQueueJobsMutationMutationVariablesType = Exact<{
  queueName: Scalars['String']['input'];
  ids: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteQueueJobsMutationMutationType = { __typename?: 'Mutation', deleteQueueJobs: Array<string | null> };

export type DeleteQueuesMutationMutationVariablesType = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteQueuesMutationMutationType = { __typename?: 'Mutation', deleteQueues: Array<{ __typename?: 'Queue', id: string, name: string } | null> };

export type PromoteQueueJobMutationMutationVariablesType = Exact<{
  queueName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type PromoteQueueJobMutationMutationType = { __typename?: 'Mutation', promoteQueueJob: { __typename?: 'QueueJob', id: string, state?: string | null, progress?: number | null, attemptsMade?: number | null, failedReason?: string | null, finishedOn?: any | null, processedOn?: any | null } };

export type RetryQueueJobMutationMutationVariablesType = Exact<{
  queueName: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}>;


export type RetryQueueJobMutationMutationType = { __typename?: 'Mutation', retryQueueJob: { __typename?: 'QueueJob', id: string, state?: string | null, progress?: number | null, attemptsMade?: number | null, failedReason?: string | null, finishedOn?: any | null, processedOn?: any | null } };

export type RetryQueueMutationMutationVariablesType = Exact<{
  queueName: Scalars['String']['input'];
}>;


export type RetryQueueMutationMutationType = { __typename?: 'Mutation', retryQueue: { __typename?: 'Queue', id: string, name: string, jobCounts: { __typename?: 'QueueJobCounts', waiting: number, active: number, completed: number, failed: number, delayed: number } } };

export type QueueJobQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
  queueName: Scalars['String']['input'];
}>;


export type QueueJobQueryQueryType = { __typename?: 'Query', job: { __typename?: 'QueueJob', id: string, name?: string | null, data?: any | null, delay?: number | null, steps?: Array<string | null> | null, timestamp?: any | null, progress?: number | null, result?: any | null, state?: string | null, stacktrace?: Array<any | null> | null, attemptsMade?: number | null, failedReason?: string | null, finishedOn?: any | null, processedOn?: any | null, logs: Array<string | null>, opts: { __typename?: 'JobOptions', priority?: number | null, timeout?: number | null, removeOnComplete?: any | null, attempts?: number | null, delay?: number | null, timestamp?: any | null, backoff?: { __typename?: 'Backoff', type: string, delay: number } | null } } };

export type QueueJobsListQueryQueryVariablesType = Exact<{
  queueName: Scalars['String']['input'];
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueueJobsListQueryQueryType = { __typename?: 'Query', queue: { __typename?: 'Queue', id: string, name: string, jobs: { __typename?: 'QueueJobConnection', count: number, nodes: Array<{ __typename?: 'QueueJob', id: string, name?: string | null, data?: any | null, delay?: number | null, steps?: Array<string | null> | null, timestamp?: any | null, progress?: number | null, result?: any | null, state?: string | null, stacktrace?: Array<any | null> | null, attemptsMade?: number | null, failedReason?: string | null, finishedOn?: any | null, processedOn?: any | null }> } } };

export type QueuesListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<QueuesFilterInputType>;
}>;


export type QueuesListQueryQueryType = { __typename?: 'Query', queues: { __typename?: 'QueueConnection', count: number, nodes: Array<{ __typename?: 'Queue', id: string, name: string, jobCounts: { __typename?: 'QueueJobCounts', waiting: number, active: number, completed: number, failed: number, delayed: number } }> } };

export type CreateRefundMutationVariablesType = Exact<{
  input: CreateRefundInputType;
}>;


export type CreateRefundMutationType = { __typename?: 'Mutation', createRefund: { __typename?: 'Refund', id: string, status: string, manual: boolean, amount: { __typename?: 'Amount', value: number, currency: string } } };

export type RefundsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type RefundsListQueryType = { __typename?: 'Query', refunds: { __typename?: 'RefundConnection', count: number, nodes: Array<{ __typename?: 'Refund', id: string, organizationId: string, status: string, manual: boolean, initiatedBy: string, description?: string | null, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, ottkitFeeAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organizationAmount?: { __typename?: 'Amount', valueUSD?: number | null } | null, organization: { __typename?: 'Organization', title: string }, payment?: { __typename?: 'Payment', userId: string, buyerEmail?: string | null, provider: string, product?: { __typename?: 'Product', title: string, type: ProductTypeType } | null } | null }> } };

export type AddRevenueShareReportCorrectionMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
}>;


export type AddRevenueShareReportCorrectionMutationType = { __typename?: 'Mutation', addRevenueShareReportCorrection: { __typename?: 'RevenueShareReport', id: string, status: string, reportAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, reportAmountInContractCurrency?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, corrections: Array<{ __typename?: 'RevenueShareReportCorrection', description: string, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } }> } };

export type RecalculateRevenueShareReportMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecalculateRevenueShareReportMutationType = { __typename?: 'Mutation', recalculateRevenueShareReport: { __typename?: 'RevenueShareReport', id: string, status: string, purchasesCount: number, feePercentages: Array<number>, refundsCount: number, disputesCount: number, salesAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, providerFeeAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, feeAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, refundsAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, disputesAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, reportAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, corrections: Array<{ __typename?: 'RevenueShareReportCorrection', description: string, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } }> } };

export type RevenueShareReportsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<RevenueShareReportsFilterInputType>;
}>;


export type RevenueShareReportsListQueryType = { __typename?: 'Query', revenueShareReports: { __typename?: 'RevenueShareReportConnection', count: number, nodes: Array<{ __typename?: 'RevenueShareReport', id: string, organizationId: string, contractId: string, period: string, status: string, purchasesCount: number, feePercentages: Array<number>, refundsCount: number, disputesCount: number, contractPaymentId?: string | null, organization?: { __typename?: 'Organization', id: string, title: string } | null, contract?: { __typename?: 'Contract', id: string, title: string, currency: string } | null, salesAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, providerFeeAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, feeAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, refundsAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, disputesAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, reportAmount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null }, reportAmountInContractCurrency?: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } | null, exchangeRate?: { __typename?: 'ExchangeRateSnapshot', rate: number, date: any, source: string } | null, corrections: Array<{ __typename?: 'RevenueShareReportCorrection', description: string, creatorId: string, createdAt: any, amount: { __typename?: 'Amount', value: number, currency: string, valueUSD?: number | null } }> }> } };

export type StreamEntrypointShowQueryQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StreamEntrypointShowQueryQueryType = { __typename?: 'Query', streamEntrypoint: { __typename?: 'StreamEntrypoint', id: string, title: string, liveConnected: boolean, lastPublishAt?: any | null, lastPublishFinishAt?: any | null, cfAccountId: string, liveInputId: string, createdAt: any, updatedAt: any, platform?: { __typename?: 'Platform', id: string, title: string } | null, stream?: { __typename?: 'Content', id: string, title: string } | null, pull?: { __typename?: 'PullState', sourceUrl: string, status: PullStatusType, attempt: number, maxAttempts: number, startedAt: any, finishedAt?: any | null, lastError?: { __typename?: 'StreamError', message: string } | null } | null } };

export type StreamEntrypointsListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<StreamEntrypointsFilterInputType>;
}>;


export type StreamEntrypointsListQueryQueryType = { __typename?: 'Query', streamEntrypoints: { __typename?: 'StreamEntrypointConnection', count: number, nodes: Array<{ __typename?: 'StreamEntrypoint', id: string, title: string, liveConnected: boolean, createdAt: any, platform?: { __typename?: 'Platform', id: string, title: string } | null, stream?: { __typename?: 'Content', id: string, title: string } | null, pull?: { __typename?: 'PullState', status: PullStatusType } | null }> } };

export type StreamsListQueryQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ContentsFilterInputType>;
}>;


export type StreamsListQueryQueryType = { __typename?: 'Query', contents: { __typename?: 'ContentConnection', count: number, nodes: Array<{ __typename?: 'Content', id: string, title: string, totalViews: number, createdAt: any, deletedAt?: any | null, preview?: { __typename?: 'Image', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, stream?: { __typename?: 'Stream', id: string, status: StreamStatusType, liveConnected: boolean, startAt?: any | null } | null }> } };

export type SubscriptionsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type SubscriptionsListQueryType = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionConnection', count: number, nodes: Array<{ __typename?: 'ProductSubscription', id: string, platformId: string, organizationId: string, status: string, startAt: any, currentPeriodEnd: any, renewSubscription: boolean, billingCyclesComplete: number, renewAttempts: number, nextRenewAttemptAt?: any | null, renewErrorReason?: RenewErrorReasonType | null, organization: { __typename?: 'Organization', title: string } }> } };

export type CreateTagTypeMutationVariablesType = Exact<{
  input: CreateTagTypeInputType;
}>;


export type CreateTagTypeMutationType = { __typename?: 'Mutation', createTagType: { __typename?: 'TagType', id: string, title: string, featured: boolean, seoDescription: boolean, defaultPreviewType: TagPreviewTypeType, customFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }> } };

export type DeleteTagTypesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteTagTypesMutationType = { __typename?: 'Mutation', deleteTagTypes: Array<{ __typename?: 'TagType', id: string } | null> };

export type RestoreTagTypesMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreTagTypesMutationType = { __typename?: 'Mutation', restoreTagTypes: Array<{ __typename?: 'TagType', id: string } | null> };

export type UpdateTagTypeMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTagTypeInputType;
}>;


export type UpdateTagTypeMutationType = { __typename?: 'Mutation', updateTagType: { __typename?: 'TagType', id: string, title: string, featured: boolean, seoDescription: boolean, defaultPreviewType: TagPreviewTypeType, customFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }> } };

export type TagTypeShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagTypeShowQueryType = { __typename?: 'Query', tagType: { __typename?: 'TagType', id: string, title: string, featured: boolean, seoDescription: boolean, defaultPreviewType: TagPreviewTypeType, createdAt: any, updatedAt: any, customFields: Array<{ __typename?: 'CustomField', type: CustomFieldTypeType, name: string, label: string, required?: boolean | null, multiple?: boolean | null, placeholder?: string | null, helperText?: string | null, options?: Array<{ __typename?: 'SelectOption', value: string, label: string } | null> | null }> } };

export type TagTypesAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompleteTagTypesFilterInputType>;
}>;


export type TagTypesAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type TagTypesListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TagTypesFilterInputType>;
}>;


export type TagTypesListQueryType = { __typename?: 'Query', tagTypes: { __typename?: 'TagTypeConnection', count: number, nodes: Array<{ __typename?: 'TagType', id: string, title: string, featured: boolean, seoDescription: boolean, createdAt: any }> } };

export type CreateTagMutationVariablesType = Exact<{
  input: CreateTagInputType;
}>;


export type CreateTagMutationType = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, title: string, description?: string | null, isFeatured: boolean } };

export type DeleteTagsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteTagsMutationType = { __typename?: 'Mutation', deleteTags: Array<{ __typename?: 'Tag', id: string } | null> };

export type RestoreTagsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreTagsMutationType = { __typename?: 'Mutation', restoreTags: Array<{ __typename?: 'Tag', id: string } | null> };

export type UpdateTagMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTagInputType;
}>;


export type UpdateTagMutationType = { __typename?: 'Mutation', updateTag: { __typename?: 'Tag', id: string, title: string, description?: string | null, isFeatured: boolean } };

export type TagShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TagShowQueryType = { __typename?: 'Query', tag: { __typename?: 'Tag', id: string, title: string, description?: string | null, isFeatured: boolean, createdAt: any, updatedAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null, image?: { __typename?: 'Image', id: string, url: any } | null } };

export type TagsAutocompleteQueryVariablesType = Exact<{
  input?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  filter?: InputMaybe<AutocompleteTagsFilterInputType>;
}>;


export type TagsAutocompleteQueryType = { __typename?: 'Query', autocomplete: { __typename?: 'AutocompleteWithID', options: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null>, value: Array<{ __typename?: 'AutocompleteOptionWithID', value: string, label: string } | null> } };

export type TagsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TagsFilterInputType>;
}>;


export type TagsListQueryType = { __typename?: 'Query', tags: { __typename?: 'TagConnection', count: number, nodes: Array<{ __typename?: 'Tag', id: string, title: string, description?: string | null, isFeatured: boolean, createdAt: any, type?: { __typename?: 'TagType', id: string, title: string } | null, image?: { __typename?: 'Image', id: string, url: any } | null }> } };

export type CreateTranslationMutationVariablesType = Exact<{
  input: CreateTranslationInputType;
}>;


export type CreateTranslationMutationType = { __typename?: 'Mutation', createTranslation: { __typename?: 'Translation', id: string } };

export type DeleteTranslationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteTranslationsMutationType = { __typename?: 'Mutation', deleteTranslations: Array<{ __typename?: 'Translation', id: string, deletedAt?: any | null } | null> };

export type RestoreTranslationsMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreTranslationsMutationType = { __typename?: 'Mutation', restoreTranslations: Array<{ __typename?: 'Translation', id: string, deletedAt?: any | null } | null> };

export type SyncTranslationWordsMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncTranslationWordsMutationType = { __typename?: 'Mutation', syncTranslationWords: { __typename?: 'Translation', id: string, variants: Array<{ __typename?: 'TranslationVariant', languageCode: string, translated: number, untranslated: number, total: number }> } };

export type UpdateTranslationMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateTranslationInputType;
}>;


export type UpdateTranslationMutationType = { __typename?: 'Mutation', updateTranslation: { __typename?: 'Translation', id: string } };

export type UpdateTranslationWordsMutationVariablesType = Exact<{
  input: UpdateTranslationWordsInputType;
}>;


export type UpdateTranslationWordsMutationType = { __typename?: 'Mutation', updateTranslationWords: { __typename?: 'Translation', id: string, variants: Array<{ __typename?: 'TranslationVariant', languageCode: string, translated: number, untranslated: number, total: number, words: Array<{ __typename?: 'TranslationWord', key: string, value?: string | null }> }> } };

export type TranslationEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TranslationEditQueryType = { __typename?: 'Query', translation: { __typename?: 'Translation', id: string, project: string, namespace: string, version: string, variants: Array<{ __typename?: 'TranslationVariant', languageCode: string, translated: number, untranslated: number, total: number, words: Array<{ __typename?: 'TranslationWord', key: string, value?: string | null }> }> } };

export type TranslationShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TranslationShowQueryType = { __typename?: 'Query', translation: { __typename?: 'Translation', id: string, project: string, namespace: string, version: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, variants: Array<{ __typename?: 'TranslationVariant', languageCode: string, translated: number, untranslated: number, total: number }> } };

export type TranslationsListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<TranslationsFilterInputType>;
}>;


export type TranslationsListQueryType = { __typename?: 'Query', translations: { __typename?: 'TranslationConnection', count: number, nodes: Array<{ __typename?: 'Translation', id: string, project: string, namespace: string, version: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, variants: Array<{ __typename?: 'TranslationVariant', languageCode: string, translated: number, untranslated: number, total: number }> }> } };

export type TranslationsOptionsQueryVariablesType = Exact<{ [key: string]: never; }>;


export type TranslationsOptionsQueryType = { __typename?: 'Query', translationsOptions: Array<{ __typename?: 'TranslationOption', value: string, label: string }> };

export type CreateUserMutationVariablesType = Exact<{
  input: CreateUserInputType;
}>;


export type CreateUserMutationType = { __typename?: 'Mutation', createUser: { __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, displayName?: string | null, isAdmin?: boolean | null, createdAt: any, updatedAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } };

export type DeleteUsersMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteUsersMutationType = { __typename?: 'Mutation', deleteUsers: Array<{ __typename?: 'User', id: string, deletedAt?: any | null } | null> };

export type RestoreUsersMutationVariablesType = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RestoreUsersMutationType = { __typename?: 'Mutation', restoreUsers: Array<{ __typename?: 'User', id: string, deletedAt?: any | null } | null> };

export type UpdateUserMutationVariablesType = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateUserInputType;
}>;


export type UpdateUserMutationType = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, displayName?: string | null, isAdmin?: boolean | null, country?: string | null, timeZone?: string | null, language?: string | null, agreeToMarketingNewsletters?: boolean | null, isPartner?: boolean | null, platformId?: string | null, currentOrganizationId?: string | null, updatedAt: any, avatar?: { __typename?: 'Avatar', id: string, url: any } | null } };

export type UserEditQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserEditQueryType = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, isAdmin?: boolean | null, isSuperAdmin?: boolean | null, country?: string | null, timeZone?: string | null, language?: string | null, agreeToMarketingNewsletters?: boolean | null, isPartner?: boolean | null, platformId?: string | null, currentOrganizationId?: string | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, currentOrganization?: { __typename?: 'Organization', id: string, title: string } | null } };

export type UserShowQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserShowQueryType = { __typename?: 'Query', user: { __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, displayName?: string | null, isAdmin?: boolean | null, isSuperAdmin?: boolean | null, isPartner?: boolean | null, isPlatformAdmin?: boolean | null, platformId?: string | null, currentOrganizationId?: string | null, apiAuthToken: string, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, sudoPartnerUrl?: any | null, sudoSiteUrl?: any | null, avatar?: { __typename?: 'Avatar', id: string, url: any } | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, currentOrganization?: { __typename?: 'Organization', id: string, title: string } | null, registrationUtm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null, lastUtm?: { __typename?: 'AttributionTouch', source?: string | null, medium?: string | null, campaign?: string | null, content?: string | null, term?: string | null, capturedAt?: any | null, backfilled: boolean, link?: { __typename?: 'AttributionLink', id: string, title: string, deleted: boolean } | null, email?: { __typename?: 'AttributionEmail', kind: AttributionEmailKindType, automationId?: string | null, automationName?: string | null, nodeId?: string | null, template?: string | null } | null } | null } };

export type UsersListQueryVariablesType = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  rowsPerPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<UsersFilterInputType>;
}>;


export type UsersListQueryType = { __typename?: 'Query', users: { __typename?: 'UserConnection', count: number, nodes: Array<{ __typename?: 'User', id: string, email?: any | null, phone?: string | null, firstName?: string | null, lastName?: string | null, middleName?: string | null, displayName?: string | null, isAdmin?: boolean | null, isSuperAdmin?: boolean | null, isPartner?: boolean | null, isPlatformAdmin?: boolean | null, platformId?: string | null, currentOrganizationId?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null, deleted?: boolean | null, platform?: { __typename?: 'Platform', id: string, title: string } | null, currentOrganization?: { __typename?: 'Organization', id: string, title: string } | null }> } };

export type UploadAvatarMutationVariablesType = Exact<{
  input: UploadAvatarInputType;
}>;


export type UploadAvatarMutationType = { __typename?: 'Mutation', file: { __typename?: 'Avatar', id: string, url: any } };

export type UploadBannerMutationVariablesType = Exact<{
  input: UploadBannerInputType;
}>;


export type UploadBannerMutationType = { __typename?: 'Mutation', file: { __typename?: 'Banner', id: string, url: any } };

export type UploadFileMutationVariablesType = Exact<{
  input: UploadFileInputType;
}>;


export type UploadFileMutationType = { __typename?: 'Mutation', file: { __typename?: 'File', id: string, url: any } };

export type UploadImageMutationVariablesType = Exact<{
  input: UploadImageInputType;
}>;


export type UploadImageMutationType = { __typename?: 'Mutation', file: { __typename?: 'Image', id: string, url: any } };

export type UploadPrivateFileMutationVariablesType = Exact<{
  input: UploadPrivateFileInputType;
}>;


export type UploadPrivateFileMutationType = { __typename?: 'Mutation', file: { __typename?: 'PrivateFile', id: string, url: any } };

export type AvatarQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AvatarQueryType = { __typename?: 'Query', file: { __typename?: 'Avatar', id: string, url: any } };

export type BannerFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BannerFileQueryType = { __typename?: 'Query', file: { __typename?: 'Banner', id: string, url: any } };

export type DaDataFindOrganizationByInnQueryVariablesType = Exact<{
  inn: Scalars['String']['input'];
  kpp?: InputMaybe<Scalars['String']['input']>;
}>;


export type DaDataFindOrganizationByInnQueryType = { __typename?: 'Query', dadataFindOrganizationByInn: { __typename?: 'DaDataOrganizationResponse', suggestions: Array<{ __typename?: 'DaDataOrganizationSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataOrganization', inn: string, kpp: string, ogrn: string, name: { __typename?: 'DaDataOrganizationName', full_with_opf: string, short_with_opf: string, full: string, short: string }, address: { __typename?: 'DaDataOrganizationAddress', value: string, unrestricted_value: string }, management?: { __typename?: 'DaDataOrganizationManagement', name: string, post: string } | null, state: { __typename?: 'DaDataOrganizationState', status: string } } }> } };

export type DaDataSuggestAddressQueryVariablesType = Exact<{
  query: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<DaDataLocationInputType>> | InputMaybe<DaDataLocationInputType>>;
}>;


export type DaDataSuggestAddressQueryType = { __typename?: 'Query', dadataSuggestAddress: { __typename?: 'DaDataAddressResponse', suggestions: Array<{ __typename?: 'DaDataAddressSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataAddress', postal_code?: string | null, country: string, region: string, city?: string | null, street?: string | null, house?: string | null, flat?: string | null, fias_id: string, geo_lat?: string | null, geo_lon?: string | null } }> } };

export type DaDataSuggestOrganizationQueryVariablesType = Exact<{
  query: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DaDataSuggestOrganizationQueryType = { __typename?: 'Query', dadataSuggestOrganization: { __typename?: 'DaDataOrganizationResponse', suggestions: Array<{ __typename?: 'DaDataOrganizationSuggestion', value: string, unrestricted_value: string, data: { __typename?: 'DaDataOrganization', inn: string, kpp: string, ogrn: string, name: { __typename?: 'DaDataOrganizationName', full_with_opf: string, short_with_opf: string, full: string, short: string }, address: { __typename?: 'DaDataOrganizationAddress', value: string, unrestricted_value: string }, management?: { __typename?: 'DaDataOrganizationManagement', name: string, post: string } | null, state: { __typename?: 'DaDataOrganizationState', status: string } } }> } };

export type FileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FileQueryType = { __typename?: 'Query', file: { __typename?: 'File', id: string, url: any } };

export type ImageFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ImageFileQueryType = { __typename?: 'Query', file: { __typename?: 'Image', id: string, url: any } };

export type PrivateFileQueryVariablesType = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PrivateFileQueryType = { __typename?: 'Query', file: { __typename?: 'PrivateFile', id: string, url: any } };
